var app = angular.module('app-shop', ['app-account-service', 'app-cart-service', 'app-helpers', 'Giant.Analytics', 'ngSanitize']);

app.controller('Shop', ['$scope', '$http', '$window', '$timeout', '$sce', '$analytics', 'helpers', '$rootScope', 'cartService', 'accountService', function ($scope, $http, $window, $timeout, $sce, $analytics, helpers, $rootScope, cartService, accountService) {
    $scope.dealers = [];
    $scope.localdealers = [];
    $scope.localstockDealers = [];
    $scope.partnumber = '';
    $scope.dealercity = '';
    $scope.productTypeId = $window.productTypeId;
    $scope.productId = $window.productId;
    $scope.latitude = '';
    $scope.longitude = '';
    $scope.localstockonly = false;
    $scope.take = 10;
    $scope.skip = 0;
    $scope.total = 0;
    $scope.localdealersCountFiltered = 0;
    $scope.nowarehousestock = false;
    $scope.containsLocalstock = false;
    $scope.errorContactInfo = '';
    $scope.errorLogin = '';
    $scope.errorPayment = '';
    $scope.errorShippingOption = '';
    $scope.errorDealerSelect = '';
    $scope.contactinfoHTML = '';
    $scope.isValidContactInfo = false;
    $scope.isValidShippingOption = false;
    $scope.isValidSelectedDealer = false;
    $scope.isValidPayment = false;
    $scope.isValidSummary = false;
    $scope.axaptaConsumerAccountNumber = '';
    $scope.checkTermsAndConditions = false;
    $scope.checkPrivacy = null;
    $scope.paymentKey = '';
    $scope.cardholderName = '';
    $scope.expirationDate = '';
    $scope.last4Digits = '';
    $scope.creditcardType = '';
    $scope.proceedPaymentButtonClicked = false;
    $scope.proceedContactInfoButtonClicked = false;
    $scope.proceedLoginButtonClicked = false;
    $scope.proceedShippingOptionButtonClicked = false;
    $scope.proceedSelectDealerButtonClicked = false;
    $scope.proceedSummaryButtonClicked = false;
    $scope.ShippingOption = {};
    $scope.Cart = {};
    $scope.Cart.Loaded = false;
    $scope.totalPriceWithTaxAndShipping = 0;
    $scope.OutOfStockValidation = {};
    $scope.lockedCart = '';
    $scope.issuer = '';
    $scope.employeeNumber = '';
    $scope.IOS = false;
    $scope.showPersonalData = false;
    //$scope.V12FinanceProduct = {
    //    Selected: '',
    //    DepositValue: 250,
    //    changeDepositValue: function () {
    //        if ($scope.V12FinanceProduct.DepositValue < $scope.V12Slider.options.minLimit) {
    //            $scope.V12FinanceProduct.DepositValue = $scope.V12Slider.options.minLimit;
    //        } else if ($scope.V12FinanceProduct.DepositValue > $scope.V12Slider.options.maxLimit) {
    //            $scope.V12FinanceProduct.DepositValue = $scope.V12Slider.options.maxLimit;
    //        }
    //    },
    //    CalculateV12: function (product) {
    //        var purchaseValue = $scope.Cart.TotalIncludingShippingCosts;

    //        var monthlypaymentResult = parseFloat((purchaseValue - $scope.V12FinanceProduct.DepositValue) * product.CalculationFactor);
    //        return monthlypaymentResult.toFixed(2);
    //    }
    //};
    $scope.slider = '';
    $scope.couponcode = '';
    $scope.coupon = null;
    $scope.promotion = null;
    $scope.showPasswordForgotten = false;
    $scope.imagesToPartnumbers = [];
    $scope.color = '';
    $scope.colors = [];
    $scope.partnumbers = [];
    $scope.stocks = [];
    $scope.stock = {};
    $scope.product = {};
    //$scope.commerzFinanzLabel = '';
    $scope.consorsFinanzLabel = '';
    //$scope.v12FinanceProducts = [];
    //$scope.v12Label = '';
    $scope.OrderConfirmation = '';
    $scope.countryId = countryId;
    $scope.onlineSizerProductFound = false;
    $scope.containsValidAddress = true;
    $scope.klarnaAuthorizationToken = null;
    $scope.GAclientId = function () {
        var ga_clientId;
        try {
            if (ga.getAll()[0].get('clientId') != undefined) {
                ga_clientId = ga.getAll()[0].get('clientId');
            }
        } catch (e) {
            //do nothing
        }
        return ga_clientId;
    }
    $scope.supplementaryItemPartnumberCode = '';
    $scope.availableStatesUSA = [
        { key: 'AL', value: 'Alabama' },
        { key: 'AK', value: 'Alaska' },
        { key: 'AZ', value: 'Arizona' },
        { key: 'AR', value: 'Arkansas' },
        { key: 'CA', value: 'California' },
        { key: 'CO', value: 'Colorado' },
        { key: 'CT', value: 'Connecticut' },
        { key: 'DE', value: 'Delaware' },
        { key: 'DC', value: 'District of Columbia' },
        { key: 'FL', value: 'Florida' },
        { key: 'GA', value: 'Georgia' },
        { key: 'HI', value: 'Hawaii' },
        { key: 'ID', value: 'Idaho' },
        { key: 'IL', value: 'Illinois' },
        { key: 'IN', value: 'Indiana' },
        { key: 'IA', value: 'Iowa' },
        { key: 'KS', value: 'Kansas' },
        { key: 'KY', value: 'Kentucky' },
        { key: 'LA', value: 'Louisiana' },
        { key: 'ME', value: 'Maine' },
        { key: 'MD', value: 'Maryland' },
        { key: 'MA', value: 'Massachusetts' },
        { key: 'MI', value: 'Michigan' },
        { key: 'MN', value: 'Minnesota' },
        { key: 'MS', value: 'Mississippi' },
        { key: 'MO', value: 'Missouri' },
        { key: 'MT', value: 'Montana' },
        { key: 'NE', value: 'Nebraska' },
        { key: 'NV', value: 'Nevada' },
        { key: 'NH', value: 'New Hampshire' },
        { key: 'NJ', value: 'New Jersey' },
        { key: 'NM', value: 'New Mexico' },
        { key: 'NY', value: 'New York' },
        { key: 'NC', value: 'North Carolina' },
        { key: 'ND', value: 'North Dakota' },
        { key: 'OH', value: 'Ohio' },
        { key: 'OK', value: 'Oklahoma' },
        { key: 'OR', value: 'Oregon' },
        { key: 'PA', value: 'Pennsylvania' },
        { key: 'PR', value: 'Puerto Rico' },
        { key: 'RI', value: 'Rhode Island' },
        { key: 'SC', value: 'South Carolina' },
        { key: 'SD', value: 'South Dakota' },
        { key: 'TN', value: 'Tennessee' },
        { key: 'TX', value: 'Texas' },
        { key: 'UT', value: 'Utah' },
        { key: 'VT', value: 'Vermont' },
        { key: 'VA', value: 'Virginia' },
        { key: 'WA', value: 'Washington' },
        { key: 'WV', value: 'West Virginia' },
        { key: 'WI', value: 'Wisconsin' },
        { key: 'WY', value: 'Wyoming' }
    ];

    $scope.availableStatesCA = [
        { key: 'AB', value: 'Alberta' },
        { key: 'BC', value: 'British Columbia' },
        { key: 'MB', value: 'Manitoba' },
        { key: 'NB', value: 'New Brunswick' },
        { key: 'NL', value: 'Newfoundland and Labrador' },
        { key: 'NS', value: 'Nova Scotia' },
        { key: 'NT', value: 'Northwest Territories' },
        { key: 'NU', value: 'Nunavut' },
        { key: 'ON', value: 'Ontario' },
        { key: 'PE', value: 'Prince Edward Island' },
        { key: 'QC', value: 'Quebec' },
        { key: 'SK', value: 'Saskatchewan' },
        { key: 'YT', value: 'Yukon' }
    ];

    $scope.creditcardAddress = {
        useShippingAddress: false,
        name: '',
        street: '',
        zipcode: '',
        city: '',
        state: ''
    };
    $scope.completeInProgress = '';
    $scope.userExists = false;
    $scope.simplefyCCNumberValid = false;
    $scope.simplefyCVVCodeValid = false;
    $scope.simplefyExpValid = false;
    $scope.simplefyValid = function () {
        return $scope.simplefyCCNumberValid && $scope.simplefyCVVCodeValid && $scope.simplefyExpValid;
    };

    $scope.toggleUseShippingAddress = function () {
        if ($scope.creditcardAddress.useShippingAddress) {
            if ($scope.firstname != undefined) {
                $scope.creditcardAddress.name = $scope.firstname + ' ' + $scope.lastname;
                $scope.creditcardAddress.street = $scope.street;
                $scope.creditcardAddress.zipcode = $scope.postalcode;
                $scope.creditcardAddress.city = $scope.city;
                $scope.creditcardAddress.state = $scope.state;
            } else {
                //nieuwe manier
                $scope.creditcardAddress.name = $scope.Cart.Order.Firstname + ' ' + $scope.Cart.Order.Lastname;
                $scope.creditcardAddress.street = $scope.Cart.Order.Street;
                $scope.creditcardAddress.zipcode = $scope.Cart.Order.Postalcode;
                $scope.creditcardAddress.city = $scope.Cart.Order.City;
                $scope.creditcardAddress.state = $scope.Cart.Order.State;
            }
        } else {
            $scope.creditcardAddress.name = '';
            $scope.creditcardAddress.street = '';
            $scope.creditcardAddress.zipcode = '';
            $scope.creditcardAddress.city = '';
            $scope.creditcardAddress.state = '';
        }
    };

    $scope.getDealers = function (localstockonly, callback, startNew) {
        cartService.MasterDomain().then(function () {
            var url = cartService._masterDomain + '/' + $window.culture + '/shop/dealers' + ($window.store != undefined && $window.store.length > 0 ? '?store=' + $window.store : '');

            if (localstockonly != undefined) {
                $scope.localstockonly = localstockonly;
            }
            if (startNew != undefined) {
                $scope.skip = 0;
            }

            //var lookupGeolocationUsingBrowser = false; //use this new feature only in test mode voor UK
            //if (window.inTestMode != undefined && window.inTestMode == true && window.countryId == 19) {
            //lookupGeolocationUsingBrowser = true;
            if ($scope.latitude != undefined && $scope.latitude != '') {//don't use browserlocation because user entered location manually
                lookupGeolocationUsingBrowser = false;
            }
            //}

            helpers.getBrowserLocation(function (lat, lng, dealercity) {
                $scope.latitude = lat != undefined && lat != '' ? lat : $scope.latitude;
                $scope.longitude = lng != undefined && lng != '' ? lng : $scope.longitude;
                $scope.dealercity = dealercity != undefined && dealercity != '' ? dealercity : $scope.dealercity;

                $http({
                    method: 'POST',
                    url: url,
                    data: {
                        partnumberCode: $scope.partnumber.code != undefined ? $scope.partnumber.code : null,
                        localstockOnly: $scope.localstockonly,
                        productType: $window.productTypeId != undefined ? $window.productTypeId : null,
                        productId: $window.productId != undefined ? $window.productId : null,
                        latitude: $scope.latitude,
                        longitude: $scope.longitude,
                        city: $scope.dealercity,
                        take: $scope.take,
                        skip: $scope.skip
                    },
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                    transformRequest: function (obj) {
                        //Deze transformatie is nodig icm Content-Type anders krijg je een 404 preflight error (http://stackoverflow.com/questions/24710503/how-do-i-post-urlencoded-form-data-with-http-in-angularjs)
                        var str = [];
                        for (var p in obj)
                            if (obj[p] != null) {
                                str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
                            }
                        return str.join("&");
                    },
                    withCredentials: true
                }).then(function (res) {
                    if (startNew != undefined && startNew == true) {
                        $scope.dealers = res.data.dealers;
                    } else {
                        $scope.dealers = $scope.dealers.concat(res.data.dealers);
                    }
                    $scope.localstockDealers = res.data.localstockDealers;
                    $scope.dealercity = res.data.city != null ? res.data.city : $scope.dealercity;
                    $scope.productTypeId = res.data.productTypeId;
                    if (res.data.productId > 0) {
                        $scope.productId = res.data.productId;
                    } else {
                        try {
                            $scope.productId = productId;
                        } catch (e) {
                            //do nothing
                        }
                    }
                    $scope.total = res.data.total;
                    $scope.nowarehousestock = res.data.nowarehousestock;
                    $scope.containsLocalstock = res.data.containsLocalstock;
                    if (res.data.lockedCart != undefined) {
                        $scope.lockedCart = res.data.lockedCart;
                    }

                    if (callback) {
                        callback();
                    }

                    /*
                    SK+NS: switched off 19-08-2019
                    if (helpers.isMobile())
                        $timeout(function () {
                            $document.find('#localstockContainer').scrollToElement({ marginTop: $document.find('#clickandcollect').offset().top - 80 });
                        });
                    */

                })
            }, lookupGeolocationUsingBrowser);
        });
    }

    $scope.getLocalDealers = function () {
        //Supplementary items doesn't support local dealer stock
        if ($scope.Cart.HasSupplementaryItems == undefined || $scope.Cart.HasSupplementaryItems == false) {
            cartService.MasterDomain().then(function () {
                var url = cartService._masterDomain + '/' + $window.culture + '/shop/dealers' + ($window.store != undefined && $window.store.length > 0 ? '?store=' + $window.store : '');

                //var lookupGeolocationUsingBrowser = false; //use this new feature only in test mode voor UK
                //if ((window.inTestMode != undefined && window.inTestMode == true) || window.countryId == 19) {
                    //lookupGeolocationUsingBrowser = true;
                    if ($scope.latitude != undefined && $scope.latitude != '') {//don't use browserlocation because user entered location manually
                        lookupGeolocationUsingBrowser = false;
                    }
                //}

                helpers.getBrowserLocation(function (lat, lng, dealercity) {
                    $scope.latitude = lat != undefined && lat != '' ? lat : $scope.latitude;
                    $scope.longitude = lng != undefined && lng != '' ? lng : $scope.longitude;
                    $scope.dealercity = dealercity != undefined && dealercity != '' ? dealercity : $scope.dealercity;

                    $http({
                        method: 'POST',
                        url: url,
                        data: {
                            partnumberCode: $scope.partnumber.code != undefined ? $scope.partnumber.code : null,
                            localstockOnly: true,
                            productType: $window.productTypeId != undefined ? $window.productTypeId : null,
                            productId: $window.productId != undefined ? $window.productId : null,
                            latitude: $scope.latitude,
                            longitude: $scope.longitude,
                            city: $scope.dealercity
                        },
                        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                        transformRequest: function (obj) {
                            //Deze transformatie is nodig icm Content-Type anders krijg je een 404 preflight error (http://stackoverflow.com/questions/24710503/how-do-i-post-urlencoded-form-data-with-http-in-angularjs)
                            var str = [];
                            for (var p in obj)
                                if (obj[p] != null) {
                                    str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
                                }
                            return str.join("&");
                        },
                        withCredentials: true
                    }).then(function (res) {
                        $scope.localdealers = res.data.dealers;
                        if (res.data.lockedCart != undefined) {
                            $scope.lockedCart = res.data.lockedCart;
                        }

                        $scope.productTypeId = res.data.productTypeId;
                        if (res.data.productId > 0) {
                            $scope.productId = res.data.productId;
                        } else {
                            try {
                                $scope.productId = productId;
                            } catch (e) {
                                //do nothing
                            }
                        }

                        /*
                        SK+NS: switched off 19-08-2019
                        if (helpers.isMobile())
                            $timeout(function () {
                                $document.find('#localstockContainer').scrollToElement({ marginTop: $document.find('#clickandcollect').offset().top - 80 });
                            });
                        */
                    })
                }, lookupGeolocationUsingBrowser);
            });
        }
    }

    $scope.showMoreDealers = function () {
        $scope.skip = $scope.skip + $scope.take;
        $scope.getDealers();
    }

    $scope.showMoreDealersLink = function () {
        if (($scope.skip + $scope.take) < $scope.total) {
            return true;
        } else {
            return false;
        }
    }

    $scope.resetDealers = function () {
        $scope.skip = 0;
        $scope.dealers = [];
    }

    $scope.selectSize = function (code, stock, productTypeId, notifyMe, shippingcosts) {
        if (productTypeId != undefined && productTypeId == 1) {
            $scope.partnumber = {
                code: code,
                stock: stock,
                type: productTypeId,
                shippingcosts: shippingcosts,
                notifyMe: notifyMe
            };
            //$scope.resetDealers();
            $scope.getLocalDealers();
            $scope.getDealers(null, null, true);
        }
    }

    $scope.selectColor = function (nrOfSizes) {
        code = $("#colorSelector").find(':selected').attr('data-partnumbercode');
        stock = $("#colorSelector").find(':selected').attr('data-stockcode');

        var imagesToPartnumbers = helpers.getImagesToPartnumbers();
        if (imagesToPartnumbers.length > 0) {

            imagesToPartnumbers = imagesToPartnumbers.filter(function (image) {
                if (image.PartnumberCodes.indexOf(code) != -1) {
                    return image;
                }
            });

            if (imagesToPartnumbers.length > 0) {
                var images = $("img[name='mainImage']");
                if (images.length > 0) {
                    for (i = 0; i < images.length; i++) {
                        var imageSrc = images[i].src;
                        images[i].src = imageSrc.replace(imageSrc.substr(imageSrc.lastIndexOf('/') + 1), imagesToPartnumbers[0].CloudinaryImage);
                    }
                }
            }
        }

        if (nrOfSizes != undefined && nrOfSizes == 1) {
            $scope.partnumber = {
                code: code,
                stock: stock,
                type: $window.productTypeId
            };

            //$scope.resetDealers();
            $scope.getLocalDealers();
            $scope.getDealers(null, null, true);
        }
    }

    $scope.getDealersFiltered = function (limit, maxdistance) {
        var result = $scope.localdealers;
        if (maxdistance > 0 | limit > 0) {
            if ($scope.partnumber != null && $scope.partnumber.stock != undefined && ($scope.partnumber.stock == 'instock' || $scope.partnumber.stock.Code == 1 || $scope.partnumber.stock.Code == 3)) {
                result = [];
                for (var i = 0; i < $scope.localdealers.length; i++) {
                    if ($scope.localdealers[i].Distance <= maxdistance) {
                        result.push($scope.localdealers[i]);
                    }
                }
            }
            if (limit > 0) {
                result = result.slice(0, limit);
            }
            $scope.localdealersCountFiltered = result.length;
        }
        return result;
    }

    $scope.getOpeningHours = function (dealer) {
        return $sce.trustAsHtml(dealer.Openinghours);
    };

    $scope.parseHtml = function (html) {
        return $sce.trustAsHtml(html);
    };

    $scope.getGeolocation = function (callback) {
        helpers.getGeolocation($scope.dealercity, function (lat, lng) {
            $scope.latitude = lat;
            $scope.longitude = lng;
            if (callback) {
                callback();
            }
        });
    };

    $scope.getGeolocationAndGetDealers = function (callback) {
        $scope.getGeolocation(function () {
            //$scope.resetDealers();
            $scope.getDealers(null, callback, true);
            $scope.getLocalDealers();
        });
    }

    $scope.getBrowserlocationAndGetDealers = function () {
        helpers.getBrowserLocation(function (lat, lng, dealercity) {
            //$scope.resetDealers();
            $scope.latitude = lat;
            $scope.longitude = lng;
            $scope.dealercity = dealercity;
            $scope.getDealers(null, null, true);
            $scope.getLocalDealers();
        });
    }

    $scope.hasLocalStock = function (dealer) {
        var result = false;

        for (var i = 0; i < $scope.localstockDealers.length; i++) {
            if ($scope.localstockDealers[i] == dealer.Code) {
                result = true;
                break;
            }
        }

        return result;
    }

    $scope.showGoogleMaps = function (dealer, viewMode, callback) {

        setTimeout(function () {
            var myLatLng = new google.maps.LatLng(dealer.Latitude, dealer.Longitude);
            var bounds = new google.maps.LatLngBounds();
            var mapOptions = {
                center: myLatLng,
                zoom: 10,
                mapTypeId: google.maps.MapTypeId.ROADMAP
            }

            var mapCanvas = document.getElementById('map-canvas-' + viewMode + '-' + dealer.Code);
            var map = new google.maps.Map(mapCanvas, mapOptions);
            var marker = new google.maps.Marker({
                position: myLatLng,
                map: map
            });
            bounds.extend(marker.getPosition());
            google.maps.event.trigger(map, "resize");

            //if (callback) {
            //    callback();
            //}
        });
    }

    $scope.showStockAlert = function () {
        $('#stockAlertModal #partnumberCode').val($scope.partnumber.code);
        $('#stockAlertModal').modal('show');
    }

    $scope.showContactForm = function () {
        $('#contactModal').modal('show');
    }

    $scope.outOfStockValidation = function () {
        cartService.MasterDomain().then(function () {
            var url = cartService._masterDomain + '/' + $window.culture + '/shop/outofstockvalidation' + ($window.store != undefined && $window.store.length > 0 ? '?store=' + $window.store : '');
            $http({
                method: 'GET',
                url: url,
                cache: false,
                withCredentials: true
            }).then(function (res) {
                $scope.OutOfStockValidation = res.data;
                $scope.errorPayment = '';
                if ($scope.OutOfStockValidation.Message != null) {
                    $scope.errorPayment = $scope.OutOfStockValidation.Message;
                }
            });
        });
    }

    $scope.updateCart = function (callback, initiator) {
        cartService.getCart(initiator).then(function () {
            $scope.Cart = cartService._cart;
            $scope.Cart.Loaded = true;
            $scope.totalPriceWithTaxAndShipping = $scope.Cart.TotalIncludingShippingCosts;

            if ($scope.Cart.ShippingOptions != undefined && $scope.Cart.ShippingOptions.length > 0) {
                $scope.ShippingOption.selected = $scope.Cart.ShippingOptions.filter(function (value) { return value.Guid == $scope.Cart.ShippingGuid && value.Disabled == false })[0];
            }

            if ($scope.Cart.Order != null && $scope.Cart.Order.Email != null && $scope.Cart.Order.Email.length > 0) {
                $scope.showPersonalData = true;
            }

            if ($('.affirm-as-low-as').length > 0) {
                //    //update Affirm value
                try {
                    affirm.ui.ready(function () {
                        affirm.ui.refresh();
                    });
                } catch (e) {
                    //do nothing
                }
            }

            if ($scope.Cart.PaymentOptions != undefined && $scope.Cart.PaymentOptions.length == 1) {
                $scope.selectPaymentOption($scope.Cart.PaymentOptions[0].code)
            }

            if ($scope.Cart.TotalIncludingShippingCosts == 0 && $scope.Cart.PaymentOptions != undefined) {
                for (var i = 0; i < $scope.Cart.PaymentOptions.length; i++) {
                    if ($scope.Cart.PaymentOptions[i].code == 'giftcard') {
                        $scope.selectPaymentOption('giftcard');
                    }
                }
            }

            if ($scope.Cart.Coupon != undefined) {
                $scope.coupon = $scope.Cart.Coupon;
            }

            if ($scope.Cart.Promotion != undefined) {
                $scope.promotion = $scope.Cart.Promotion;
            }

            $scope.validateAddress();

            if (callback) {
                callback();
            }
        })
    }

    $scope.removeCartItem = function (item) {
        cartService.MasterDomain().then(function () {
            var url = cartService._masterDomain + '/' + $window.culture + '/shop/removecartitem/' + item.Id + '/json?expanded=true&r=' + Math.random() + ($window.store != undefined && $window.store.length > 0 ? '&store=' + $window.store : '');
            $http({
                method: 'GET',
                url: url,
                cache: false,
                withCredentials: true
            }).then(function (res) {
                $scope.updateCart(function () {
                    //Opnieuw out of stock bepalen. Zodat melding weg is.
                    $scope.outOfStockValidation();
                }, 'RemoveCartItem');
                $rootScope.$broadcast('cartUpdated');
                $scope.isValidContactInfo = false;
                $scope.isValidShippingOption = false;
                $scope.isValidSelectedDealer = false;
                $scope.isValidPayment = false;
                $scope.isValidSummary = false;
                $('#collapseContactInfo').collapse('show');
                $('#collapseShippingOptions').collapse('hide');
                $('#collapseDealers').collapse('hide');
                $('#collapsePayment').collapse('hide');
                $('#collapseSummary').collapse('hide');

                AnalyticsBuilder.create(window.inTestMode ? { debug: true } : {}).addProduct({
                    'id': item.Product.Partnumber != undefined ? item.Product.Partnumber.Code : '',
                    'name': item.Product.Name,
                    'quantity': item.Quantity
                }).asRemoveFromCart({
                    'id': item.Product.Partnumber != undefined ? item.Product.Partnumber.Code : '',
                    'name': item.Product.Name,
                    'quantity': item.Quantity
                }).send();
            });
        });
    }

    $scope.removeDealer = function () {
        cartService.MasterDomain().then(function () {
            var url = cartService._masterDomain + '/' + $window.culture + '/shop/removedealer?r=' + Math.random() + ($window.store != undefined && $window.store.length > 0 ? '&store=' + $window.store : '');
            $http({
                method: 'GET',
                url: url,
                cache: false,
                withCredentials: true
            }).then(function (res) {
                $scope.updateCart(null, 'RemoveDealer');
                $scope.isValidContactInfo = false;
                $scope.isValidShippingOption = false;
                $scope.isValidSelectedDealer = false;
                $scope.isValidPayment = false;
                $scope.isValidSummary = false;
                $('#collapseContactInfo').collapse('show');
                $('#collapseShippingOptions').collapse('hide');
                $('#collapseDealers').collapse('hide');
                $('#collapsePayment').collapse('hide');
                $('#collapseSummary').collapse('hide');
            });
        });
    }

    $scope.showDealerSelector = function () {
        return ($scope.countryId == 19 || $scope.countryId == 48 || $scope.countryId == 6 || $scope.countryId == 8 || $scope.countryId == 29 || $scope.countryId == 14 || $scope.countryId == 15 || $scope.countryId == 17 || ($scope.countryId == 43 && $scope.ShippingOption != undefined && $scope.ShippingOption.selected != undefined && $scope.ShippingOption.selected.DeliveryType != undefined && $scope.ShippingOption.selected.DeliveryType != 1) || ($scope.Cart.ContainsOnlyGear == false && ($scope.ShippingOption.selected != null && $scope.ShippingOption.selected.OnlyDirectshipmentBikes == false))) && ($scope.Cart.Dealer == null || $scope.isValidSelectedDealer == true) && $scope.Cart.ContainsOnlyGiftcard == false;
    }

    $scope.ValidatedAddressAtGoogleMaps = false;
    $scope.ValidateAddressAtGoogleMaps = function () {
        getLatLng($scope.Cart.Order.Street + ' ' + $scope.Cart.Order.Postalcode + ' ' + $scope.Cart.Order.City + ' ' + country, function (a, b, c, d) {
            try {
                if (d.length > 0) {
                    for (var i = 0; i < d[0].address_components.length; i++) {
                        if (d[0].address_components[i].types[0] == 'country') {
                            if (d[0].address_components[i].short_name.toLowerCase() == countryCode) {
                                $scope.ValidatedAddressAtGoogleMaps = true;
                                $scope.$apply();
                                $scope.proceedContactInfoAfterValidation();
                                return true;
                            }
                        }
                    }
                }
            } catch (e) {
                //exceptionHandling(e.message, e.stack);
            }
            //exceptionHandling('Cart contains address different from country', 'Google Maps input: ' + $scope.Cart.Order.Street + ' ' + $scope.Cart.Order.Postalcode + ' ' + $scope.Cart.Order.City + ' ' + country + '\nGoogle Maps result: ' + c);
            $scope.ValidatedAddressAtGoogleMaps = true;
            $scope.errorContactInfo = lblIncorrectAddress;
            $scope.proceedContactInfoButtonClicked = false;
            $scope.$apply();
            return false;
        });
    }

    $scope.proceedContactInfo = function () {

        //check required fields
        $scope.errorContactInfo = '';
        $scope.proceedContactInfoButtonClicked = true;
        if ($scope.formContactInfo.$valid) {

            // valid
            if ($scope.ValidatedAddressAtGoogleMaps == false && window.validateAddressAtGoogleMaps != undefined && window.validateAddressAtGoogleMaps == true) {
                $scope.ValidateAddressAtGoogleMaps();
            } else {
                $scope.proceedContactInfoAfterValidation();
            }

        } else {

            if ($scope.formContactInfo.$error.required != undefined && $scope.formContactInfo.$error.required.length > 0) {
                $scope.errorContactInfo += lblMakeSureAllRequiredFieldsAreEntered;
            }
            if ($scope.formContactInfo.$error.email != undefined && $scope.formContactInfo.$error.email.length > 0) {
                $scope.errorContactInfo += lblWrongEmailHasBeenEntered;
            }
            // SK 13-10-2020
            angular.element('input.ng-invalid').first().focus();
        }
    }

    $scope.proceedContactInfoAfterValidation = function () {
        $scope.contactinfoHTML = '';
        $scope.dealercity = $scope.postalcode + ' ' + $scope.city;
        var search = $scope.street + ' ' + $scope.postalcode + ' ' + $scope.city + ',' + country;
        if ($scope.state != undefined) {
            $scope.dealercity += ', ' + $scope.state;
        }

        //if (version != undefined && version == 2) {
        $scope.dealercity = $scope.Cart.Order.Street + ' ' + $scope.Cart.Order.Postalcode + ' ' + $scope.Cart.Order.City;
        if ($scope.Cart.Order.State != undefined) {
            $scope.dealercity += ', ' + $scope.Cart.Order.State;
        }
        search = $scope.Cart.Order.Street + ' ' + $scope.Cart.Order.Postalcode + ' ' + $scope.Cart.Order.City + ',' + country;
        //}

        getLatLng(search, function (lat, lng, formatted_address) {
            $('#Order_OrderLatitude').val(lat);
            $('#Order_OrderLongitude').val(lng);
            $('#Order_OrderGAclientId').val($scope.GAclientId());

            //submit form to collect contact info
            cartService.MasterDomain().then(function () {
                var url = cartService._masterDomain + '/' + $window.culture + '/shop/setcontactinfo' + ($window.store != undefined && $window.store.length > 0 ? '?store=' + $window.store : '');
                $http({
                    method: 'POST',
                    url: url,
                    data: $('form[name="formOrder"]').serialize(),
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                    withCredentials: true
                }).then(function (res) {
                    $scope.isValidContactInfo = res.data.result;
                    $scope.isValidShippingOption = false;
                    $scope.isValidSelectedDealer = false;
                    $scope.isValidPayment = false;
                    $scope.isValidSummary = false;
                    $scope.proceedContactInfoButtonClicked = false;
                    if (res.data.result == true) {
                        $scope.contactinfoHTML = $sce.trustAsHtml(res.data.html);
                        $scope.axaptaConsumerAccountNumber = res.data.axaptaConsumerAccountNumber;
                        $scope.updateCart(function () {
                            if ($scope.Cart.ContainsOnlyGiftcard == true) {
                                $('#collapsePayment').collapse('show');
                            } else {
                                $('#collapseShippingOptions').collapse('show');
                            }
                            $('#collapseContactInfo').collapse('hide');
                        }, 'SetContactInfo'); //especially for gear items. Tax will change.

                        $analytics.createBuilder().asCheckoutStep({
                            step: 1,
                            option: $scope.axaptaConsumerAccountNumber === '' ? 'NotLoggedIn' : 'LoggedIn',
                            checkout_step: 1,
                            checkout_option: $scope.axaptaConsumerAccountNumber === '' ? 'NotLoggedIn' : 'LoggedIn'
                        }).send();
                    } else {
                        if (res.data.userExists != undefined && res.data.userExists == true) {
                            $scope.userExists = true;
                        } else {
                            $scope.errorContactInfo = res.data.error;
                        }
                        $('#collapseShippingOptions').collapse('hide');
                    }
                });
            });
        });

    }


    $scope.Login = function () {
        accountService.Login($scope.loginEmail, $scope.loginPassword, true, true).then(function () {
            if (accountService._account.result != null && accountService._account.result.Token.length > 0) {
                $scope.Cart.Order.Firstname = accountService._account.result.Details.OrderFirstname;
                $scope.Cart.Order.Lastname = accountService._account.result.Details.OrderLastname;
                $scope.Cart.Order.Street = accountService._account.result.Details.OrderStreet;
                $scope.Cart.Order.OrderAddress2 = accountService._account.result.Details.OrderAddress2;
                $scope.Cart.Order.Postalcode = accountService._account.result.Details.OrderPostalcode;
                $scope.Cart.Order.City = accountService._account.result.Details.OrderCity;
                $scope.Cart.Order.State = accountService._account.result.Details.OrderState;
                $scope.Cart.Order.Phone = accountService._account.result.Details.OrderPhone;
                $scope.Cart.Order.Email = accountService._account.result.Details.OrderEmail;
                $scope.Cart.Order.AxaptaConsumerAccountNumber = accountService._account.result.Details.OrderAxaptaConsumerAccountNumber;
                $scope.Cart.Order.Gender = accountService._account.result.Details.GenderToFormat;
                $scope.Cart.Order.BirthDate = accountService._account.result.Details.BirthDateToFormat;
                $scope.Cart.Order.AddToNewsletter = accountService._account.result.Details.OrderAddToNewsletter;
                $scope.showPersonalData = true;
                $scope.validateAddress();
            } else {
                try {
                    $scope.errorLogin = accountService._account.error;
                } catch (e) {
                    $scope.errorLogin = 'An error occurred. Please try again';
                }

                // Find e-mail input field 
                var emailInputField = document.getElementById('Email');
                emailInputField.focus();

            }
        });
    }

    $scope.proceedLogin = function () {
        $scope.errorLogin = '';
        $scope.proceedLoginButtonClicked = true;

        if ($scope.formLogin.$valid) {
            cartService.MasterDomain().then(function () {
                var url = cartService._masterDomain + '/' + $window.culture + '/shop/login' + ($window.store != undefined && $window.store.length > 0 ? '?store=' + $window.store : '');
                $http({
                    method: 'POST',
                    url: url,
                    data: { email: $scope.loginEmail, password: $scope.loginPassword },
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                    transformRequest: function (obj) {
                        //Deze transformatie is nodig icm Content-Type anders krijg je een 404 preflight error (http://stackoverflow.com/questions/24710503/how-do-i-post-urlencoded-form-data-with-http-in-angularjs)
                        var str = [];
                        for (var p in obj)
                            str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
                        return str.join("&");
                    },
                    withCredentials: true
                }).then(function (res) {
                    if (res.data.error.length == 0) {
                        //if (version != undefined && version == 2) {
                        $scope.Cart.Order.Firstname = res.data.result.OrderFirstname;
                        $scope.Cart.Order.Lastname = res.data.result.OrderLastname;
                        $scope.Cart.Order.Street = res.data.result.OrderStreet;
                        $scope.Cart.Order.OrderAddress2 = res.data.result.OrderAddress2;
                        $scope.Cart.Order.Postalcode = res.data.result.OrderPostalcode;
                        $scope.Cart.Order.City = res.data.result.OrderCity;
                        $scope.Cart.Order.State = res.data.result.OrderState;
                        $scope.Cart.Order.Phone = res.data.result.OrderPhone;
                        $scope.Cart.Order.Email = res.data.result.OrderEmail;
                        $scope.Cart.Order.AxaptaConsumerAccountNumber = res.data.result.OrderAxaptaConsumerAccountNumber;

                        $('#loginModal').modal('hide');
                        //rename create account label
                        //$('#lnkCreateAccount').html(lblChangePassword);
                        $scope.errorLogin = '';
                        $scope.proceedLoginButtonClicked = false;
                    } else {
                        $scope.errorLogin = res.data.error;
                    }
                });
            });
        } else {
            if ($scope.formLogin.$error.required != undefined && $scope.formLogin.$error.required.length > 0) {
                $scope.errorLogin = lblMakeSureAllRequiredFieldsAreEntered;
            }
            if ($scope.formLogin.$error.email != undefined && $scope.formLogin.$error.email.length > 0) {
                $scope.errorLogin += lblWrongEmailHasBeenEntered;
            }
        }
    }

    $scope.Logout = function () {
        accountService.Logout();
        //location.reload();
        //$scope.resetContactInfo();
    }

    $scope.proceedPasswordForgotten = function () {
        $http({
            method: 'POST',
            url: '/' + $window.culture + '/shop/resetpasswordrequest' + ($window.store != undefined && $window.store.length > 0 ? '?store=' + $window.store : ''),
            data: { email: $scope.loginEmail }
        }).then(function (res) {
            $scope.messagePasswordForgotten = '';
            $scope.errorPasswordForgotten = '';
            if (res.data.result == true) {
                $scope.messagePasswordForgotten = res.data.message;
            } else {
                $scope.errorPasswordForgotten = res.data.message;
            }
        });
    }

    $scope.selectShippingOption = function () {
        //var shippingOptionSelected = $scope.ShippingOption.selected;
        //if (shippingOptionSelected.OnlyDirectshipmentBikes == true) {
        //    $('#panel-dealerselector').hide();
        //    //$('#headingPayment .nr').text(parseInt($('#headingShippingOptions .nr').text()) + 1);
        //} else {
        //    $('#panel-dealerselector').show();
        //    //$('#headingPayment .nr').text(parseInt($('#headingShippingOptions .nr').text()) + 2);
        //}
    };

    $scope.proceedShippingOption = function () {
        $scope.errorShippingOption = '';
        $scope.proceedShippingOptionButtonClicked = true;
        var shippingOptionSelected = $scope.ShippingOption.selected;

        if (shippingOptionSelected != null) {
            cartService.MasterDomain().then(function () {
                var url = cartService._masterDomain + '/' + $window.culture + '/shop/setshippingoption' + ($window.store != undefined && $window.store.length > 0 ? '?store=' + $window.store : '');
                $http({
                    method: 'POST',
                    url: url,
                    data: { guid: shippingOptionSelected.Guid },
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                    transformRequest: function (obj) {
                        //Deze transformatie is nodig icm Content-Type anders krijg je een 404 preflight error (http://stackoverflow.com/questions/24710503/how-do-i-post-urlencoded-form-data-with-http-in-angularjs)
                        var str = [];
                        for (var p in obj)
                            str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
                        return str.join("&");
                    },
                    withCredentials: true
                }).then(function (res) {
                    $scope.isValidShippingOption = res.data;
                    $scope.isValidSelectedDealer = false;
                    $scope.isValidPayment = false;
                    $scope.isValidSummary = false;
                    if (shippingOptionSelected.DeliveryTypeToString == 'homedelivery' && $scope.Cart.UseLocalStock != undefined && $scope.Cart.UseLocalStock == false && $scope.Cart.Dealer != null) {
                        //remove dealer when switching to homedelivery and not local stock
                        $scope.removeDealer();
                    }

                    //set search dealer field at home address
                    $scope.dealercity = $scope.Cart.Order.Street + ' ' + $scope.Cart.Order.Postalcode + ' ' + $scope.Cart.Order.City;

                    //UpdateCart();
                    $scope.updateCart(null, 'SetShippingOption');

                    $analytics.createBuilder().asCheckoutStep({
                        step: 2,
                        option: shippingOptionSelected.DeliveryTypeToString,
                        checkout_step: 2,
                        checkout_option: shippingOptionSelected.DeliveryTypeToString
                    }).send();

                    if ($('#panel-dealerselector').is(":visible")) {
                        $scope.getGeolocationAndGetDealers(function () {
                            $('#collapseDealers').collapse('show');
                            $('#collapseShippingOptions').collapse('hide');
                            $scope.proceedShippingOptionButtonClicked = false;
                        });
                    } else if ($('#panel-GiftcardOrCoupon').is(":visible")) {
                        $('#collapseGiftcardOrCoupon').collapse('show');
                        $('#collapseShippingOptions').collapse('hide');
                        $scope.proceedShippingOptionButtonClicked = false;
                    } else {
                        $('#collapsePayment').collapse('show');
                        $('#collapseShippingOptions').collapse('hide');
                        $scope.proceedShippingOptionButtonClicked = false;
                    }
                    $scope.isIOS();
                });
            });
        } else {
            $scope.errorShippingOption = lblSelectDeliveryOption;
        }
    }

    $scope.proceedSelectDealer = function (dealer) {
        $scope.proceedSelectDealerButtonClicked = dealer.Code;
        $scope.errorDealerSelect = '';

        cartService.MasterDomain().then(function () {
            var url = cartService._masterDomain + '/' + $window.culture + '/shop/setdealercode' + ($window.store != undefined && $window.store.length > 0 ? '?store=' + $window.store : '');
            $http({
                method: 'POST',
                url: url,
                data: { dealercode: dealer.Code },
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                transformRequest: function (obj) {
                    //Deze transformatie is nodig icm Content-Type anders krijg je een 404 preflight error (http://stackoverflow.com/questions/24710503/how-do-i-post-urlencoded-form-data-with-http-in-angularjs)
                    var str = [];
                    for (var p in obj)
                        str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
                    return str.join("&");
                },
                withCredentials: true
            }).then(function (res) {
                if (res.data == 'True') {
                    $scope.updateCart(function () {
                        $scope.isValidSelectedDealer = true;
                        $scope.isValidPayment = false;
                        $scope.isValidSummary = false;
                        $scope.outOfStockValidation();

                        if ($('#panel-GiftcardOrCoupon').is(":visible")) {
                            $('#collapseGiftcardOrCoupon').collapse('show');
                            $('#collapseDealers').collapse('hide');
                            $scope.proceedSelectDealerButtonClicked = false;
                        } else {
                            $('#collapsePayment').collapse('show');
                            $('#collapseDealers').collapse('hide');
                            $scope.proceedSelectDealerButtonClicked = false;
                        }

                    }, 'SetDealerCode');

                    if ($scope.hasLocalStock(dealer)) {
                        //double check product is in local stock. Else show user message product is only in warehouse stock.
                        $scope.outOfStockValidation();
                    }

                    //$analytics.createBuilder().asCheckoutStep({
                    //    step: 2.5,
                    //    option: dealer.Code,
                    //    checkout_step: 2.5,
                    //    checkout_option: dealer.Code
                    //}).send(); Stap overgeslagen omdat er al 3 steps zijn gedefinieerd
                } else {
                    $scope.errorDealerSelect = res.data;
                    $scope.proceedSelectDealerButtonClicked = '';
                }

                $scope.isIOS();
            });
        });
    }

    $scope.proceedGiftcard = function () {
        if ($scope.giftcard != undefined) {
            $scope.actionButtonGiftcardOrCouponClicked = true;
            $scope.giftcard.Valid = true;
            cartService.MasterDomain().then(function () {
                var url = cartService._masterDomain + '/' + $window.culture + '/shop/validategiftcard' + ($window.store != undefined && $window.store.length > 0 ? '?store=' + $window.store : '');
                $http({
                    method: 'POST',
                    url: url,
                    data: { giftcard: $scope.giftcard.Number },
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                    transformRequest: function (obj) {
                        //Deze transformatie is nodig icm Content-Type anders krijg je een 404 preflight error (http://stackoverflow.com/questions/24710503/how-do-i-post-urlencoded-form-data-with-http-in-angularjs)
                        var str = [];
                        for (var p in obj)
                            str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
                        return str.join("&");
                    },
                    withCredentials: true
                }).then(function (res) {
                    $scope.giftcard.Number = '';
                    $scope.updateCart(function () {
                        $scope.giftcard = res.data;
                        $scope.actionButtonGiftcardOrCouponClicked = false;
                    }, 'ValidateGiftcard');
                });
            });
        }
    }

    $scope.removeGiftcard = function (item) {
        $scope.actionButtonGiftcardOrCouponClicked = true;
        cartService.MasterDomain().then(function () {
            var url = cartService._masterDomain + '/' + $window.culture + '/shop/removegiftcard' + ($window.store != undefined && $window.store.length > 0 ? '?store=' + $window.store : '');
            $http({
                method: 'POST',
                url: url,
                data: { giftcardpublic: item },
                withCredentials: true
            }).then(function (res) {
                $scope.updateCart(function () {
                    $scope.actionButtonGiftcardOrCouponClicked = false;
                }, 'RemoveGiftcard');
            });
        });
    }

    $scope.proceedGiftcardOrCoupon = function () {
        $scope.errorGiftcardOrCoupon = '';
        $scope.proceedGiftcardOrCouponButtonClicked = true;

        $scope.isValidGiftcardOrCoupon = true;
        $('#collapsePayment').collapse('show');
        $('#collapseGiftcardOrCoupon').collapse('hide');
        $scope.proceedGiftcardOrCouponButtonClicked = false;
    }

    $scope.selectPaymentOption = function (paymentOption) {
        if (paymentOption != undefined) {
            $scope.paymentoption = paymentOption;
        }
        if ($scope.paymentoption == 'klarnaPayLater') {
            $scope.initiateKlarna('pay_later');
        }
        if ($scope.paymentoption == 'klarnaOverTime') {
            $scope.initiateKlarna('pay_over_time');
        }
        if ($scope.paymentoption == 'simplefy') {
            $scope.initiateSimplefy();
        }
        if ($scope.paymentoption == 'santander') {
            $scope.initiateSantander();
        }
    }

    $scope.proceedPayment = function (isMobile) {
        var billingAddressValid = false;
        $scope.errorPayment = '';
        $scope.proceedPaymentButtonClicked = true;
        if (($scope.checkTermsAndConditions == true && ($scope.checkPrivacy == true || $scope.checkPrivacy == null)) || isMobile) {
            if ($scope.paymentoption != null) {
                if ($scope.paymentoption == 'stripe') {
                    if ($scope.formStripe.$valid) {
                        //all required fields have been entered. Create token.
                        // The billing address needs to be validated and saved for USA & Canada
                        if (countryId == 1 || countryId == 10 || countryId == 16) {
                            cartService.MasterDomain().then(function () {
                                var url = cartService._masterDomain + '/' + $window.culture + '/shop/setbillingaddress' + ($window.store != undefined && $window.store.length > 0 ? '?store=' + $window.store : '');
                                $http({
                                    method: 'POST',
                                    url: url,
                                    data: $('form[name="formOrder"]').serialize(),
                                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                                    withCredentials: true
                                }).then(function (res) {
                                    if (res.data.result == true) {
                                        _completeStripePayment(isMobile);
                                    } else {
                                        $scope.errorPayment = res.data.error;
                                        $scope.proceedPaymentButtonClicked = false;
                                    }
                                });
                            });
                        } else {
                            // Other countries don't have seperate fields for the billing address, we need to set the fields to the delivery address
                            $scope.creditcardAddress.name = $scope.Cart.Order.Firstname + ' ' + $scope.Cart.Order.Lastname;
                            $scope.creditcardAddress.street = $scope.Cart.Order.Street;
                            $scope.creditcardAddress.zipcode = $scope.Cart.Order.Postalcode;
                            $scope.creditcardAddress.city = $scope.Cart.Order.City;
                            $scope.creditcardAddress.state = $scope.Cart.Order.State;

                            _completeStripePayment(isMobile);
                        }
                    }
                    else {
                        if ($scope.formStripe.$error.required != undefined && $scope.formStripe.$error.required.length > 0) {
                            $scope.errorPayment = lblMakeSureAllRequiredFieldsAreEntered;
                        }
                    }
                }
                else if ($scope.paymentoption == 'stripe2') {
                    if ($scope.formStripe2.$valid) {
                        //all required fields have been entered. Create token.
                        // The billing address needs to be validated and saved for USA & Canada
                        if (countryId == 1 || countryId == 10 || countryId == 16) {
                            cartService.MasterDomain().then(function () {
                                var url = cartService._masterDomain + '/' + $window.culture + '/shop/setbillingaddress' + ($window.store != undefined && $window.store.length > 0 ? '?store=' + $window.store : '');
                                $http({
                                    method: 'POST',
                                    url: url,
                                    data: $('form[name="formOrder"]').serialize(),
                                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                                    withCredentials: true
                                }).then(function (res) {
                                    if (res.data.result == true) {
                                        if (!isMobile) {
                                            _completeStripePayment2();
                                        } else {
                                            $scope.proceedPaymentButtonClicked = false;
                                            $('#collapseSummary').collapse('show');
                                            $('#collapsePayment').collapse('hide');
                                        }
                                    } else {
                                        $scope.errorPayment = res.data.error;
                                        $scope.proceedPaymentButtonClicked = false;
                                    }
                                });
                            });
                        } else {
                            // Other countries don't have seperate fields for the billing address, we need to set the fields to the delivery address
                            $scope.creditcardAddress.name = $scope.Cart.Order.Firstname + ' ' + $scope.Cart.Order.Lastname;
                            $scope.creditcardAddress.street = $scope.Cart.Order.Street;
                            $scope.creditcardAddress.zipcode = $scope.Cart.Order.Postalcode;
                            $scope.creditcardAddress.city = $scope.Cart.Order.City;
                            $scope.creditcardAddress.state = $scope.Cart.Order.State;

                            if (!isMobile) {
                                _completeStripePayment2();
                            } else {
                                $scope.proceedPaymentButtonClicked = false;
                                $('#collapseSummary').collapse('show');
                                $('#collapsePayment').collapse('hide');
                            }
                        }
                    }
                    else {
                        if ($scope.formStripe2.$error.required != undefined && $scope.formStripe2.$error.required.length > 0) {
                            $scope.errorPayment = lblMakeSureAllRequiredFieldsAreEntered;
                        }
                    }
                }
                else if ($scope.paymentoption == 'simplefy') {
                    if ($scope.formSimplefy.$valid && $scope.simplefyValid()) {
                        //all required fields have been entered. Create token.
                        // The billing address needs to be validated and saved for USA & Canada
                        if (countryId == 1 || countryId == 10 || countryId == 16) {
                            cartService.MasterDomain().then(function () {
                                var url = cartService._masterDomain + '/' + $window.culture + '/shop/setbillingaddress' + ($window.store != undefined && $window.store.length > 0 ? '?store=' + $window.store : '');
                                $http({
                                    method: 'POST',
                                    url: url,
                                    data: $('form[name="formOrder"]').serialize(),
                                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                                    withCredentials: true
                                }).then(function (res) {
                                    if (res.data.result == true) {
                                        if (!isMobile) {
                                            _completeSimplefyPayment();
                                        } else {
                                            $scope.proceedPaymentButtonClicked = false;
                                            $('#collapseSummary').collapse('show');
                                            $('#collapsePayment').collapse('hide');
                                        }
                                    } else {
                                        $scope.errorPayment = res.data.error;
                                        $scope.proceedPaymentButtonClicked = false;
                                    }
                                });
                            });
                        } else {
                            // Other countries don't have seperate fields for the billing address, we need to set the fields to the delivery address
                            $scope.creditcardAddress.name = $scope.Cart.Order.Firstname + ' ' + $scope.Cart.Order.Lastname;
                            $scope.creditcardAddress.street = $scope.Cart.Order.Street;
                            $scope.creditcardAddress.zipcode = $scope.Cart.Order.Postalcode;
                            $scope.creditcardAddress.city = $scope.Cart.Order.City;
                            $scope.creditcardAddress.state = $scope.Cart.Order.State;

                            if (!isMobile) {
                                _completeSimplefyPayment();
                            } else {
                                $scope.proceedPaymentButtonClicked = false;
                                $('#collapseSummary').collapse('show');
                                $('#collapsePayment').collapse('hide');
                            }
                        }
                    }
                    else {
                        if ($scope.formSimplefy.$error.required != undefined && $scope.formSimplefy.$error.required.length > 0) {
                            $scope.errorPayment = lblMakeSureAllRequiredFieldsAreEntered;
                        } else if (!$scope.simplefyValid()) {
                            $scope.errorPayment = lblInvalidCreditCardInformation;
                        }
                    }
                }
                else if ($scope.paymentoption == 'klarnaPayLater') {
                    if ($scope.KlarnaErrorMessage.length == 0) {
                        if (!isMobile) {
                            _completeKlarnaPayment('pay_later');
                        } else {
                            $scope.proceedPaymentButtonClicked = false;
                            $('#collapseSummary').collapse('show');
                            $('#collapsePayment').collapse('hide');
                        }
                    } else {
                        $scope.errorPayment = $scope.KlarnaErrorMessage;
                    }
                }
                else if ($scope.paymentoption == 'klarnaOverTime') {
                    if ($scope.KlarnaErrorMessage.length == 0) {
                        if (!isMobile) {
                            _completeKlarnaPayment('pay_over_time');
                        } else {
                            $scope.proceedPaymentButtonClicked = false;
                            $('#collapseSummary').collapse('show');
                            $('#collapsePayment').collapse('hide');
                        }
                    } else {
                        $scope.errorPayment = $scope.KlarnaErrorMessage;
                    }
                }
                else if ($scope.paymentoption == 'payeezy') {
                    if ($scope.formPayeezy.$valid) {
                        //all required fields have been entered. Create token.

                        // The billing address needs to be validated and saved for USA & Canada
                        if (countryId == 1 || countryId == 10 || countryId == 16) {
                            cartService.MasterDomain().then(function () {
                                var url = cartService._masterDomain + '/' + $window.culture + '/shop/setbillingaddress' + ($window.store != undefined && $window.store.length > 0 ? '?store=' + $window.store : '');
                                $http({
                                    method: 'POST',
                                    url: url,
                                    data: $('form[name="formOrder"]').serialize(),
                                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                                    withCredentials: true
                                }).then(function (res) {
                                    if (res.data.result == true) {
                                        _completePayeezyPayment(isMobile);
                                    } else {
                                        $scope.errorPayment = res.data.error;
                                        $scope.proceedPaymentButtonClicked = false;
                                    }
                                });
                            });
                        } else {
                            // Other countries don't have seperate fields for the billing address, we need to set the fields to the delivery address
                            //if (version != undefined && version == 2) {
                            $scope.creditcardAddress.name = $scope.Cart.Order.Firstname + ' ' + $scope.Cart.Order.Lastname;
                            $scope.creditcardAddress.street = $scope.Cart.Order.Street;
                            $scope.creditcardAddress.zipcode = $scope.Cart.Order.Postalcode;
                            $scope.creditcardAddress.city = $scope.Cart.Order.City;
                            $scope.creditcardAddress.state = $scope.Cart.Order.State;
                            _completeStripePayment(isMobile);
                        }
                    }
                    else {
                        if ($scope.formPayeezy.$error.required != undefined && $scope.formPayeezy.$error.required.length > 0) {
                            $scope.errorPayment = lblMakeSureAllRequiredFieldsAreEntered;
                        }
                    }
                } else {
                    $scope.isValidPayment = true;
                    $scope.isValidSummary = false;
                    if (!isMobile) {
                        $scope.completeOrder(function () {
                            $scope.isValidPayment = true;
                            $scope.proceedPaymentButtonClicked = false;
                        });
                    } else {
                        $scope.proceedPaymentButtonClicked = false;
                        $('#collapseSummary').collapse('show');
                        $('#collapsePayment').collapse('hide');
                    }
                }
            } else {
                $scope.errorPayment = lblSelectPaymentOption;
            }
        } else {
            $scope.errorPayment = lblPleaseAgreeToTermsAndConditions;

            // SK 13-10-2020
            angular.element('.terms-and-privacy input.ng-invalid').first().focus();
        }
    }

    var _completeStripePayment = function (isMobile) {
        Stripe.card.createToken({
            number: $scope.creditcardnumber,
            cvc: $scope.cvc,
            exp_month: $scope.creditcardmonth,
            exp_year: $scope.creditcardyear,
            address_zip: $scope.creditcardAddress.zipcode,
            name: $scope.creditcardAddress.name,
            address_line1: $scope.creditcardAddress.street
        }, function (status, response) {
            if (response.error) {
                $scope.errorPayment = response.error.message;
                $scope.$apply();
            } else {
                $scope.paymentKey = response.id;
                $scope.$apply();
                if (!isMobile) {
                    $scope.completeOrder(function () {
                        $scope.isValidPayment = true;
                        $scope.isValidSummary = false;
                        $scope.proceedPaymentButtonClicked = false;
                    });
                } else {
                    $scope.isValidPayment = true;
                    $scope.isValidSummary = false;
                    $scope.proceedPaymentButtonClicked = false;
                    $scope.$apply();
                    $('#collapseSummary').collapse('show');
                    $('#collapsePayment').collapse('hide');
                }
            }
        });
    };

    var _completeStripePayment2 = function () {
        //var cardholderName = document.getElementById('Order.OrderBillingAddressName');
        //$scope.proceedSummaryButtonClicked = false;

        cartService.MasterDomain().then(function () {
            var url = cartService._masterDomain + '/' + $window.culture + '/shop/get-stripe-paymentintent?' + Math.random() + '&ga_clientId=' + $scope.GAclientId() + ($window.store != undefined && $window.store.length > 0 ? '&store=' + $window.store : '');
            $http({
                method: 'GET',
                url: url,
                cache: false,
                withCredentials: true
            }).then(function (res) {
                if (res.data != null && res.data.success == true) {
                    stripe.handleCardPayment(
                        res.data.clientsecret, cardNumberElement, {
                        payment_method_data: {
                            billing_details: {
                                address: {
                                    city: $scope.creditcardAddress.city,
                                    //country: null,
                                    line1: $scope.creditcardAddress.street,
                                    postal_code: $scope.creditcardAddress.zipcode,
                                    state: $scope.creditcardAddress.state
                                },
                                email: $scope.Cart.Order.Email,
                                name: $scope.creditcardAddress.name
                            }
                        }
                    }
                    ).then(function (result) {
                        if (result.paymentIntent != null && result.paymentIntent.status == 'succeeded') {
                            // The payment has succeeded. Display a success message.
                            $scope.completeOrder(function () {
                                $scope.isValidPayment = true;
                                $scope.isValidSummary = false;
                                $scope.proceedPaymentButtonClicked = false;
                            });
                        } else {
                            var message = 'Stripe error (unknown)';
                            if (result.error != null) {
                                message = 'Stripe: ' + result.error.message + ' (' + result.error.code + ')';
                            }
                            //unlock cart to continue checkout
                            $scope.unlockCart(message);
                            // Display error.message in your UI.
                            $scope.errorPayment = result.error.message;
                            $scope.$apply();
                            //exceptionHandling(message, 'CartGuid: ' + $scope.Cart.Guid);
                        }
                    });
                } else {
                    $timeout(function () {
                        $scope.errorPayment = res.data.exception.Message != undefined ? res.data.exception.Message : res.data.exception;
                    });
                }
            })
        })
    };

    var _completeSimplefyPayment = function () {
        // Start the simplefy payment request. The code will continue in the callback of the CollectJS configure function (check initiateSimplefy function)
        CollectJS.startPaymentRequest();
    }

    var _completePayeezyPayment = function (isMobile) {
        $scope.errorPayment = '';
        //var $form = $scope.formPayeezy;
        var apiKey = document.getElementById("apikey").value;
        var js_security_key = document.getElementById("js_security_key").value;
        var auth = 'true';
        var ta_token = document.getElementById("ta_token").value;
        Payeezy.setApiKey(apiKey);
        Payeezy.setJs_Security_Key(js_security_key);
        Payeezy.setTa_token(ta_token);
        Payeezy.setAuth(auth);
        Payeezy.setCurrency('USD');
        Payeezy.createToken(function (status, response) {
            if (status != 201) {
                if (response.error && status != 400) {
                    var error = response["error"];
                    var errormsg = error["messages"];
                    var errorcode = JSON.stringify(errormsg[0].code, null, 4);
                    var errorMessages = JSON.stringify(errormsg[0].description, null, 4);
                    $scope.errorPayment = errorMessages;
                    $scope.$apply();
                }
                else {
                    //if (status == 400 || status == 500) {
                    var errorMessages = "";
                    for (var i in response.Error.messages) {
                        errorMessages += response.Error.messages[i].description + ' ';
                    }
                    $scope.errorPayment = errorMessages;
                    $scope.$apply();
                }

            } else {
                $scope.paymentKey = response.token.value;
                $scope.cardholderName = response.token.cardholder_name;
                $scope.expirationDate = response.token.exp_date;
                $scope.creditcardType = response.token.type;
                $scope.$apply();
                if (!isMobile) {
                    $scope.completeOrder(function () {
                        $scope.isValidPayment = true;
                        $scope.isValidSummary = false;
                        $scope.proceedPaymentButtonClicked = false;
                    });
                } else {
                    $scope.isValidPayment = true;
                    $scope.isValidSummary = false;
                    $scope.proceedPaymentButtonClicked = false;
                    $scope.$apply();
                    $('#collapseSummary').collapse('show');
                    $('#collapsePayment').collapse('hide');
                }
            }
        });
    };

    var _completeKlarnaPayment = function (code) {
        Klarna.Payments.authorize({
            payment_method_category: code
        }, function (res) {
            if (res.approved) {
                $scope.klarnaAuthorizationToken = res.authorization_token;
                $scope.completeOrder(function () {
                    $scope.isValidPayment = true;
                    $scope.isValidSummary = false;
                    $scope.proceedPaymentButtonClicked = false;
                });
            } else {
                $scope.unlockCart();
                $scope.proceedPaymentButtonClicked = false;
            }
        });
    }

    $scope.proceedSummary = function () {
        $scope.proceedSummaryButtonClicked = true;
        $scope.errorPayment = '';
        if ($scope.checkTermsAndConditions == true && ($scope.checkPrivacy == true || $scope.checkPrivacy == null)) {
            if ($scope.paymentoption == 'stripe2' && isMobile) {
                _completeStripePayment2(isMobile);
            } else if ($scope.paymentoption == 'klarnaPayLater' && isMobile) {
                _completeKlarnaPayment('pay_later');
            } else if ($scope.paymentoption == 'klarnaOverTime' && isMobile) {
                _completeKlarnaPayment('pay_over_time');
            } else {
                $scope.completeOrder(function () {
                    $scope.isValidSummary = true;
                    $scope.isValidSummary = false;
                    $scope.proceedSummaryButtonClicked = false;
                });
            }

        } else {
            $scope.errorPayment = lblPleaseAgreeToTermsAndConditions;
        }
    }

    $scope.collapseIsValid = function (collapseName) {
        //Check of all required fields have been set
        switch (collapseName) {
            case 'contactinfo':
                return $scope.isValidContactInfo;
            case 'shippingoptions':
                return $scope.isValidShippingOption;
            case 'dealers':
                return $scope.isValidSelectedDealer;
            case 'giftcardorcoupon':
                return $scope.isValidGiftcardOrCoupon;
            case 'payment':
                return $scope.isValidPayment;
            case 'summary':
                return $scope.isValidSummary;
            default:
                return false;
        }
    }

    $scope.collapseIsAuthorizedToEdit = function (collapseName) {
        //Check of this collapse block can be opened when previous collapse blocks are valid
        switch (collapseName) {
            case 'contactinfo':
                return true;
            case 'shippingoptions':
                return $scope.collapseIsValid('contactinfo');
            case 'dealers':
                return $scope.collapseIsValid('contactinfo') && $scope.collapseIsValid('shippingoptions');
            case 'giftcardorcoupon':
                return $scope.collapseIsValid('contactinfo') && $scope.collapseIsValid('shippingoptions');
            case 'payment':
                return $scope.collapseIsValid('contactinfo') && $scope.collapseIsValid('shippingoptions') && $scope.collapseIsValid('dealers');
            case 'summary':
                return $scope.collapseIsValid('contactinfo') && $scope.collapseIsValid('shippingoptions') && $scope.collapseIsValid('dealers') && $scope.collapseIsValid('payment');
            default:
                return false;
        }
    }

    //$scope.SetV12Product = function (callbackSuccess) {
    //    cartService.MasterDomain().then(function () {
    //        var url = cartService._masterDomain + '/' + $window.culture + '/shop/setv12product' + ($window.store != undefined && $window.store.length > 0 ? '?store=' + $window.store : '');
    //        $http({
    //            method: 'POST',
    //            url: url,
    //            data: { productId: $scope.V12FinanceProduct.Selected, deposit: $scope.V12FinanceProduct.DepositValue },
    //            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    //            transformRequest: function (obj) {
    //                //Deze transformatie is nodig icm Content-Type anders krijg je een 404 preflight error (http://stackoverflow.com/questions/24710503/how-do-i-post-urlencoded-form-data-with-http-in-angularjs)
    //                var str = [];
    //                for (var p in obj)
    //                    str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
    //                return str.join("&");
    //            },
    //            withCredentials: true
    //        }).then(function (res) {
    //            if (res.data == true) {
    //                if (callbackSuccess) {
    //                    callbackSuccess();
    //                }
    //            }
    //        });
    //    });
    //}

    $scope.completeOrder = function (callbackSuccess) {
        $scope.completeInProgress = true;

        cartService.MasterDomain().then(function () {
            var url = cartService._masterDomain + '/' + $window.culture + '/shop/completeorder' + ($window.store != undefined && $window.store.length > 0 ? '?store=' + $window.store : '');
            $http({
                method: 'POST',
                url: url,
                data: {
                    paymentoption: $scope.paymentoption,
                    paymentKey: $scope.paymentKey,
                    issuer: $scope.issuer,
                    employeeNumber: $scope.employeeNumber,
                    changeLocalStockToWarehouseStock: ($scope.OutOfStockValidation.OutOfStock == true && $scope.OutOfStockValidation.ContinueOrder == true),
                    cardholderName: $scope.cardholderName,
                    expirationDate: $scope.expirationDate,
                    last4Digits: $scope.last4Digits,
                    creditcardType: $scope.creditcardType,
                    ga_clientId: $scope.GAclientId(),
                    klarnaAuthorizationToken: $scope.klarnaAuthorizationToken
                },
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                transformRequest: function (obj) {
                    //Deze transformatie is nodig icm Content-Type anders krijg je een 404 preflight error (http://stackoverflow.com/questions/24710503/how-do-i-post-urlencoded-form-data-with-http-in-angularjs)
                    var str = [];
                    for (var p in obj)
                        str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
                    return str.join("&");
                },
                withCredentials: true
            }).then(function (res) {
                if (res.data.Result == true) {
                    //payment successfully.
                    $analytics.createBuilder().asCheckoutStep({
                        step: 3,
                        option: $scope.paymentoption,
                        checkout_step: 3,
                        checkout_option: $scope.paymentoption
                    }).send(function () {
                        $scope.OrderConfirmation = res.data;
                        $scope.OutOfStockValidation = res.data.OutOfStockValidation;

                        //Power reviews
                        //if (res.data.PowerReviewCredentials != null && window.inTestMode == false) {
                        //    $scope.sendToPowerReviews();
                        //}

                        if (callbackSuccess && $scope.paymentoption != 'paypal') {
                            callbackSuccess();
                        }

                        if (res.data.RedirectUrl != null && res.data.RedirectUrl.length > 0) {
                            //redirect to V12 / CF
                            window.location = res.data.RedirectUrl;
                        } else if ($scope.paymentoption == 'affirm') {
                            //redirect to affirm
                            $scope.initiateAffirm();
                        }
                        else if ($scope.paymentoption == 'paypal') {
                            //redirect to paypal
                            $scope.initiatePayPal(res.data.Guid);
                        }
                        else if ($scope.paymentoption == 'verifone') {
                            //redirect to paypal
                            $scope.initiateVerifone(res.data.Guid);
                        }
                        else if ($scope.paymentoption == 'paybright') {
                            //redirect to paybright
                            $scope.initiatePayBright(res.data.Guid);
                        } else {
                            //Redirect to confirmationpage
                            window.location = '/' + $window.culture + '/shop/confirmation/' + res.data.Guid + ($window.store != undefined && $window.store.length > 0 ? '/?store=' + $window.store : '/?cartguidvalidation=' + res.data.CartGuidValidation);
                        }
                    });
                } else {
                    //something went wrong
                    $scope.errorPayment = res.data.ExceptionMessage;
                    $scope.completeInProgress = '';
                }
            });
        });
    }

    //$scope.sendToPowerReviews = function () {
    //    try {

    //        var tracker = POWERREVIEWS.tracker.createTracker({
    //            merchantGroupId: $scope.OrderConfirmation.PowerReviewCredentials.MerchantGroupID
    //        });

    //        var orderFeed = {
    //            merchantGroupId: $scope.OrderConfirmation.PowerReviewCredentials.MerchantGroupID,
    //            merchantId: $scope.OrderConfirmation.PowerReviewCredentials.MerchantID,
    //            locale: window.cultureFull.replace('-', '_'),
    //            //merchantUserId: 'testuserid',
    //            marketingOptIn: true,
    //            userEmail: $scope.Cart.Order.Email,
    //            userFirstName: $scope.Cart.Order.Firstname,
    //            userLastName: $scope.Cart.Order.Lastname,
    //            orderId: $scope.OrderConfirmation.OrderId,
    //            orderItems: []
    //        };
    //        for (var i = 0; i < $scope.Cart.CartItems.length; i++) {
    //            orderFeed.orderItems.push({
    //                page_id: ($scope.Cart.CartItems[i].Product.ProductTypeId == 2 ? 'g-' : 'b-') + $scope.Cart.CartItems[i].Product.Id,
    //                product_name: $scope.Cart.CartItems[i].Product.Name,
    //                quantity: $scope.Cart.CartItems[i].Quantity,
    //                unit_price: $scope.Cart.CartItems[i].Product.PriceOriginal
    //            });
    //        }
    //        tracker.trackCheckout(orderFeed);

    //    } catch (e) {
    //        //exceptionHandling('Powerreviews-error', JSON.stringify(orderFeed));
    //        window.console && window.console.log(e)
    //    }
    //}

    $scope.initiateSimplefy = function () {
        // Call configure function to redraw the iFrames and to register the callback function.
        CollectJS.configure({
            "timeoutDuration": 10000,
            "timeoutCallback": function () {
                $scope.errorPayment = lblCreditCardTimeout;
                $scope.$apply();
            },
            "callback": function (response) {
                if (response && response.card) {
                    if (response.card.number) {
                        // Get the last 4 digits
                        var startAt = response.card.number.length - 4;
                        $scope.last4Digits = response.card.number.substr(startAt, 4);
                    }

                    if (response.card.exp) {
                        $scope.expirationDate = response.card.exp;
                    }
                }

                $scope.paymentKey = response.token;
                $scope.$apply();
                if (!$scope.IsMobile()) {
                    $scope.completeOrder(function () {
                        $scope.isValidPayment = true;
                        $scope.isValidSummary = false;
                        $scope.proceedPaymentButtonClicked = false;
                    });
                } else {
                    $scope.isValidPayment = true;
                    $scope.isValidSummary = false;
                    $scope.proceedPaymentButtonClicked = false;
                    $scope.$apply();
                    $('#collapseSummary').collapse('show');
                    $('#collapsePayment').collapse('hide');
                }
            },
            "validationCallback": function (field, status, message) {
                console.log(message);

                switch (field) {
                    case 'ccnumber':
                        $scope.simplefyCCNumberValid = status;
                        break;
                    case 'cvv':
                        $scope.simplefyCVVCodeValid = status;
                        break;
                    case 'ccexp':
                        $scope.simplefyExpValid = status;
                        break;
                    default:
                        console.warn('Simplefy field ' + field + ' is unknown');
                }
            }
        });
    }

    $scope.initiateAffirm = function () {
        if ($scope.Cart.AffirmExtraData != null) {
            $window.affirm.checkout({
                "config": {
                    "financial_product_key": (divisionCode == '600' ? "5TR9Z5CAL20TY8HQ" : "M4MI78P3LSG07I94")
                },

                "financing_program": $scope.Cart.AffirmExtraData.FinancingProgram,

                "merchant": {
                    "user_cancel_url": $scope.Cart.AffirmExtraData.CancelUrl,
                    "user_confirmation_url": $scope.Cart.AffirmExtraData.ConfirmationUrl,
                    "user_confirmation_url_action": "POST",
                },

                "items": $scope.Cart.AffirmExtraData.CartItems,
                "order_id": $scope.OrderConfirmation.OrderId,
                "metadata": {
                    "shipping_type": $scope.OrderConfirmation.ShippingGuid
                },
                "shipping": {
                    "name": {
                        "first": $scope.Cart.Order.Firstname,
                        "last": $scope.Cart.Order.Lastname
                    },
                    "address": {
                        "line1": $scope.Cart.Order.Street,
                        "line2": "",
                        "city": $scope.Cart.Order.City,
                        "state": $scope.Cart.Order.State,
                        "zipcode": $scope.Cart.Order.Postalcode
                    },
                    "phone_number": $scope.Cart.Order.Phone,
                    "email": $scope.Cart.Order.Email
                },
                "billing": {
                    "name": {
                        "first": $scope.Cart.Order.Firstname,
                        "last": $scope.Cart.Order.Lastname
                    },
                    "address": {
                        "line1": $scope.Cart.Order.Street,
                        "line2": "",
                        "city": $scope.Cart.Order.City,
                        "state": $scope.Cart.Order.State,
                        "zipcode": $scope.Cart.Order.Postalcode
                    },
                    "phone_number": $scope.Cart.Order.Phone,
                    "email": $scope.Cart.Order.Email,
                },
                "shipping_amount": Math.round($scope.OrderConfirmation.ShippingCosts * 100),
                "tax_amount": Math.round($scope.OrderConfirmation.Tax * 100),
                "total": Math.round($scope.OrderConfirmation.Total * 100),
            });
            $window.affirm.checkout.post();
        }
    }

    $scope.initiatePayPal = function (guid) {
        cartService.MasterDomain().then(function () {
            var url = cartService._masterDomain + '/' + $window.culture + '/shop/paypalinitiate/' + guid + '?r=' + Math.random() + ($window.store != undefined && $window.store.length > 0 ? '&store=' + $window.store : '');
            $http({
                method: 'GET',
                url: url,
                cache: false,
                withCredentials: true
            }).then(function (res) {
                $('body').append(res.data);
                $('form#paypal').submit();
            });
        });
    }

    $scope.initiateVerifone = function (guid) {
        cartService.MasterDomain().then(function () {
            var url = cartService._masterDomain + '/' + $window.culture + '/shop/verifoneinitiate/' + guid + '?r=' + Math.random() + ($window.store != undefined && $window.store.length > 0 ? '&store=' + $window.store : '');
            $http({
                method: 'GET',
                url: url,
                cache: false,
                withCredentials: true
            }).then(function (res) {
                $('body').append(res.data);
                $('form#verifone').submit();
            });
        });
    }

    $scope.initiateKlarna = function (code) {
        $scope.KlarnaErrorMessage = '';
        cartService.MasterDomain().then(function () {
            var url = cartService._masterDomain + '/' + $window.culture + '/shop/klarna-initiate?r=' + Math.random() + ($window.store != undefined && $window.store.length > 0 ? '&store=' + $window.store : '');
            $http({
                method: 'GET',
                url: url,
                cache: false,
                withCredentials: true
            }).then(function (res) {
                try {
                    if (res.data.key != null) {
                        Klarna.Payments.init({
                            client_token: res.data.key
                        });
                        Klarna.Payments.load({
                            container: '#klarna-payments-container-' + code,
                            payment_method_category: code
                        }, function (res) {
                            console.debug(res);
                            if (res.show_form == false) {
                                $scope.KlarnaErrorMessage = 'This payment option is not available';
                            }
                        });
                    } else {
                        $scope.KlarnaErrorMessage = res.data.error;
                    }
                } catch (e) {
                    // Handle error.
                }
            });
        });
    }

    $scope.initiatePayBright = function (guid) {
        cartService.MasterDomain().then(function () {
            var url = cartService._masterDomain + '/' + $window.culture + '/shop/paybrightinitiate/' + guid + '?r=' + Math.random() + ($window.store != undefined && $window.store.length > 0 ? '&store=' + $window.store : '');
            $http({
                method: 'GET',
                url: url,
                cache: false,
                withCredentials: true
            }).then(function (res) {
                $('body').append(res.data);
                $('form#paybright').submit();
            });
        });
    }

    $scope.initiateSantander = function (code) {
        $scope.SantanderErrorMessage = '';
        $scope.SantanderSuccessMessage = '';
        $scope.SantanderKey = '';
        $scope.proceedPaymentButtonClicked = true;
        cartService.MasterDomain().then(function () {
            var url = cartService._masterDomain + '/' + $window.culture + '/shop/santander-initiate?r=' + Math.random() + ($window.store != undefined && $window.store.length > 0 ? '&store=' + $window.store : '');
            $http({
                method: 'GET',
                url: url,
                cache: false,
                withCredentials: true
            }).then(function (res) {
                $scope.proceedPaymentButtonClicked = false;
                try {
                    if (res.data.key != null) {
                        $scope.SantanderKey = res.data.key;
                        $scope.SantanderSuccessMessage = res.data.message;
                    } else {
                        $scope.SantanderErrorMessage = res.data.message;
                    }
                } catch (e) {
                    // Handle error.
                }
            });
        });
    }

    //TODO: Implement Enhanced E-Commerce Tracking for Coupon Codes
    $scope.proceedCoupon = function () {
        if ($scope.coupon != null && $scope.coupon.Code.length > 0) {
            $scope.actionButtonGiftcardOrCouponClicked = true;
            cartService.MasterDomain().then(function () {
                var url = cartService._masterDomain + '/' + $window.culture + '/shop/validatecoupon' + ($window.store != undefined && $window.store.length > 0 ? '?store=' + $window.store : '');
                $http({
                    method: 'POST',
                    url: url,
                    data: { coupon: $scope.coupon.Code },
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                    transformRequest: function (obj) {
                        //Deze transformatie is nodig icm Content-Type anders krijg je een 404 preflight error (http://stackoverflow.com/questions/24710503/how-do-i-post-urlencoded-form-data-with-http-in-angularjs)
                        var str = [];
                        for (var p in obj)
                            str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
                        return str.join("&");
                    },
                    withCredentials: true
                }).then(function (res) {
                    $scope.updateCart(function () {
                        $scope.coupon = res.data;

                        if ($scope.coupon.Code.toLowerCase() == 'undefined') {
                            $scope.coupon.Code = '';
                        }

                        if ($scope.coupon.STS != null) {
                            $scope.paymentoption = 'sts';
                        }
                        //get dealers again when coupon is related to dealers
                        if ($scope.coupon.DealerCodes != null && $scope.coupon.DealerCodes.length > 0) {
                            $scope.getGeolocationAndGetDealers();
                        }

                        if ($scope.coupon.Valid == false) {
                            angular.element('#CouponCode').focus();
                        }
                        $scope.actionButtonGiftcardOrCouponClicked = false;
                    }, 'ValidateCoupon');
                });
            });
        }
    }

    $scope.removeCoupon = function () {
        $scope.actionButtonGiftcardOrCouponClicked = true;
        cartService.MasterDomain().then(function () {
            var url = cartService._masterDomain + '/' + $window.culture + '/shop/removecoupon' + ($window.store != undefined && $window.store.length > 0 ? '?store=' + $window.store : '');
            $http({
                method: 'POST',
                url: url,
                withCredentials: true
            }).then(function (res) {
                $scope.updateCart(function () {
                    //get dealers again when coupon is related to dealers
                    if ($scope.coupon.DealerCodes != null && $scope.coupon.DealerCodes.length > 0) {
                        $scope.getGeolocationAndGetDealers();
                    }

                    $scope.coupon = null;
                    $scope.actionButtonGiftcardOrCouponClicked = false;
                }, 'RemoveCoupon');
            });
        });
    }

    $scope.unlockCart = function (message) {
        cartService.MasterDomain().then(function () {
            var url = cartService._masterDomain + '/' + $window.culture + '/shop/unlock-cart' + ($window.store != undefined && $window.store.length > 0 ? '?store=' + $window.store : '');
            $http({
                method: 'POST',
                url: url,
                withCredentials: true,
                data: { message: message }
            });
        });
    }

    $scope.initPartnumbers = function (id, productTypeId, useGlobalCatalogue) {
        $http({
            method: 'GET',
            url: '/' + $window.culture + '/shop/productselector/' + id + '/' + productTypeId + '/' + useGlobalCatalogue.toLowerCase()
        }).then(function (res) {
            $scope.partnumbers = res.data.Partnumbers;
            $scope.product = res.data.Product;
            //$scope.commerzFinanzLabel = res.data.CommerzFinanzLabel;
            $scope.consorsFinanzLabel = res.data.ConsorsFinanzLabel;
            $scope.colors = res.data.Colors;
            $scope.priceDifferences = res.data.PriceDifferences;
            $scope.hasVariations = res.data.HasVariations;
            $scope.useLocalStockGear = res.data.UseLocalStockGear;

            //remove gallery images
            if ($scope.product.CloudinaryImagesToPartnumbers != null) {
                var tempImages = [];
                for (var i = 0; i < $scope.product.CloudinaryImagesToPartnumbers.length; i++) {
                    if ($scope.product.CloudinaryImagesToPartnumbers[i].CloudinaryImage.IsGalleryImage == false) {
                        tempImages.push($scope.product.CloudinaryImagesToPartnumbers[i]);
                    }
                }
                $scope.product.CloudinaryImagesToPartnumbers = tempImages;
            }

            if ($scope.colors.length > 0) {
                if ($scope.product.CloudinaryImagesToPartnumbers != null && $scope.product.CloudinaryImagesToPartnumbers[0].Color != null) {
                    $scope.color = $scope.product.CloudinaryImagesToPartnumbers[0].Color;
                } else {
                    $scope.color = $scope.colors[0];
                }
            } else {
                $scope.color = "one-color"
            }

            setTimeout(function () {
                angular.element('#colorSelect .selectpicker').selectpicker('refresh');
                angular.element('#partnumberSelect .selectpicker').selectpicker('refresh');
            });

            //set default size + color when partnumbercode is located in querystring. Necessary for google feed.
            if (getParameterByName('partnumber') != null && getParameterByName('partnumber').length > 0) {
                $scope.partnumberCode = getParameterByName('partnumber');
                $scope.selectPartnumber();
                $scope.color = $scope.partnumber.color;
                $scope.selectColor2();
                $scope.partnumberCode = getParameterByName('partnumber');
                $scope.selectPartnumber();
            } else if ($scope.product.CloudinaryImagesToPartnumbers != null) {
                $scope.selectColor2($scope.product.CloudinaryImagesToPartnumbers[0]);
            } else {
                $scope.selectColor2();
            }
        });
    }

    $scope.initImages = function (id, productTypeId, useGlobalCatalogue) {
        $http({
            method: 'GET',
            url: '/' + $window.culture + '/shop/productselector/' + id + '/' + productTypeId + '/' + useGlobalCatalogue.toLowerCase()
        }).then(function (res) {
            $scope.product = res.data.Product;

            if ($scope.product.CloudinaryImagesToPartnumbers != undefined && $scope.product.CloudinaryImagesToPartnumbers.length > 0) {
                //remove gallery images
                var tempImages = [];
                for (var i = 0; i < $scope.product.CloudinaryImagesToPartnumbers.length; i++) {
                    if ($scope.product.CloudinaryImagesToPartnumbers[i].CloudinaryImage.IsGalleryImage == false) {
                        tempImages.push($scope.product.CloudinaryImagesToPartnumbers[i]);
                    }
                }
                $scope.product.CloudinaryImagesToPartnumbers = tempImages;

                var cloudinaryImage = $scope.product.CloudinaryImagesToPartnumbers[0];

                $scope.activeImageMain = cloudinaryImage.CloudinaryImage.ImageUrlMain;
                $scope.activeImageLarge = cloudinaryImage.CloudinaryImage.ImageUrlLarge;
                $scope.activeImageSmall = cloudinaryImage.CloudinaryImage.ImageUrlSmall;
                $scope.activeImageThumb = cloudinaryImage.CloudinaryImage.ImageUrlThumb;
                $scope.activeImageZoom = cloudinaryImage.CloudinaryImage.ImageUrlMegaZoom;
                $scope.activeImageIndex = $scope.product.CloudinaryImagesToPartnumbers.indexOf(cloudinaryImage);
            }
        });
    }

    $scope.partnumbersByColor = function () {
        var temp = [];
        for (i = 0; i < $scope.partnumbers.length; i++) {
            if ($scope.color == "one-color" || $scope.partnumbers[i].color == $scope.color) {
                temp.push($scope.partnumbers[i]);
            }
        }
        if ($scope.hasVariations && $scope.partnumber.code != null) {
            var cloudinaryImage = $scope.cloudinaryImageByPartnumberCode($scope.partnumber.code);
            $scope.activeImageMain = cloudinaryImage.CloudinaryImage.ImageUrlMain;
            $scope.activeImageLarge = cloudinaryImage.CloudinaryImage.ImageUrlLarge;
            $scope.activeImageSmall = cloudinaryImage.CloudinaryImage.ImageUrlSmall;
            $scope.activeImageThumb = cloudinaryImage.CloudinaryImage.ImageUrlThumb;
            $scope.activeImageZoom = cloudinaryImage.CloudinaryImage.ImageUrlMegaZoom;
            $scope.activeImageIndex = $scope.product.CloudinaryImagesToPartnumbers.indexOf(cloudinaryImage);
        }
        return temp;
    }

    $scope.cloudinaryImageByPartnumberCode = function (partnumberCode) {
        for (i = 0; i < $scope.product.CloudinaryImagesToPartnumbers.length; i++) {
            for (var j = 0; j < $scope.product.CloudinaryImagesToPartnumbers[i].PartnumberCodes.length; j++) {
                if ($scope.product.CloudinaryImagesToPartnumbers[i].PartnumberCodes[j] == partnumberCode) {
                    return $scope.product.CloudinaryImagesToPartnumbers[i];
                }
            }
        }
    }

    $scope.selectColor2 = function (cloudinaryImage) {
        $scope.partnumber = '';
        $scope.partnumberCode = '';
        $scope.localdealers = [];
        $scope.localdealersCountFiltered = 0;
        if ($scope.color != undefined && $scope.color.length > 0 && $scope.product.CloudinaryImagesToPartnumbers != undefined && $scope.product.CloudinaryImagesToPartnumbers.length > 0) {
            if (cloudinaryImage == null) {
                cloudinaryImage = $scope.cloudinaryImageByPartnumberCode($scope.partnumbersByColor()[0].code);
            }
            // Check if cloudinaryImage object is found. If not, then probably the partnumbercodes are not linked yet to the cloudinary images. Show first image found in this case.
            if (!cloudinaryImage) {
                cloudinaryImage = $scope.product.CloudinaryImagesToPartnumbers[0];
            }

            $scope.activeImageMain = cloudinaryImage.CloudinaryImage.ImageUrlMain;
            $scope.activeImageLarge = cloudinaryImage.CloudinaryImage.ImageUrlLarge;
            $scope.activeImageSmall = cloudinaryImage.CloudinaryImage.ImageUrlSmall;
            $scope.activeImageThumb = cloudinaryImage.CloudinaryImage.ImageUrlThumb;
            $scope.activeImageZoom = cloudinaryImage.CloudinaryImage.ImageUrlMegaZoom;
            $scope.activeImageIndex = $scope.product.CloudinaryImagesToPartnumbers.indexOf(cloudinaryImage);
        }

        if ($scope.partnumbersByColor().length == 1) {
            $scope.partnumberCode = $scope.partnumbersByColor()[0].code;
            $scope.partnumber = $scope.partnumbersByColor()[0];
            $scope.selectPartnumber();
        } else if (cloudinaryImage != null && $scope.hasVariations && $scope.colors.length == 1) {
            //speciaal voor producten als wheelsystems
            for (var i = 0; i < cloudinaryImage.PartnumberCodes.length; i++) {
                for (var j = 0; j < $scope.partnumbers.length; j++) {
                    if ($scope.partnumbers[j].code == cloudinaryImage.PartnumberCodes[i]) {
                        $scope.partnumberCode = cloudinaryImage.PartnumberCodes[i];
                        $scope.selectPartnumber();
                        break;
                    }
                }
            }
        } else {

        }

        setTimeout(function () {
            angular.element('#colorSelect .selectpicker').selectpicker('refresh');
            angular.element('#partnumberSelect .selectpicker').selectpicker('refresh');
        });
        //setTimeout(function () {
        //    angular.element('.selectpicker').selectpicker('refresh');
        //    //angular.element('#partnumberSelect .selectpicker').selectpicker('refresh');
        //});
    }

    $scope.selectPartnumber = function () {
        for (i = 0; i < $scope.partnumbers.length; i++) {
            if ($scope.partnumbers[i].code == $scope.partnumberCode) {
                $scope.partnumber = $scope.partnumbers[i];
                break;
            }
        }
        if ($scope.product.ProductType == 1 || $scope.useLocalStockGear) {
            if ($scope.partnumber != null) {
                $scope.getLocalDealers();
                $scope.getDealers(null, null, true);
            } else {
                $scope.localdealers = [];
                $scope.localdealersCountFiltered = 0;
            }
        }

        $scope.supplementaryItemPartnumberCode = '';
        setTimeout(function () {
            angular.element('#supplementaryItemSelect .selectpicker').selectpicker('refresh');
        });
    }

    $scope.addCartItem = function (dealerCode) {
        if ($scope.product.ProductType == 3) {
            $scope.errorGiftcard = '';
            $scope.addCartItemError = '';
            if ($scope.formGiftcard.$valid == false) {
                $scope.errorGiftcard = lblRequiredFields;
                return;
            }
            if ($scope.GiftcardPrice == undefined || $scope.GiftcardPrice.length == 0) {
                $scope.errorGiftcard = window.lblNoAmount;
                return;
            }
            if ($scope.GiftcardPrice < 1 || $scope.GiftcardPrice > 10000) {
                $scope.errorGiftcard = window.lblMaxMinAmount;
                return;
            }
        }
        cartService.MasterDomain().then(function () {
            var url = cartService._masterDomain + '/' + $window.culture + '/shop/addcartitem' + ($window.store != undefined && $window.store.length > 0 ? '?store=' + $window.store : '');
            var data = {
                productId: $scope.product.Id,
                partnumberCode: $scope.partnumber.code,
                productType: $scope.product.ProductType,
                quantity: 1,
                globalCatalogue: $scope.product.IsGlobalCatalogue,
                GAclientId: $scope.GAclientId(),
                supplementaryItemPartnumberCode: $scope.supplementaryItemPartnumberCode,
                giftcardPrice: $scope.GiftcardPrice,
                giftcardRecipientFirstname: $scope.GiftcardRecipientFirstname != undefined ? $scope.GiftcardRecipientFirstname : '',
                giftcardRecipientLastname: $scope.GiftcardRecipientLastname != undefined ? $scope.GiftcardRecipientLastname : '',
                giftcardRecipientEmail: $scope.GiftcardRecipientEmail != undefined ? $scope.GiftcardRecipientEmail : '',
                giftcardMessage: $scope.GiftcardMessage != undefined ? $scope.GiftcardMessage : '',
                giftcardSenddate: $scope.GiftcardSenddate != undefined ? $scope.GiftcardSenddate : '',
                giftcardBrand: $scope.GiftcardBrand != undefined ? $scope.GiftcardBrand : ''
            };
            if (dealerCode != null) {
                data["dealerCode"] = dealerCode;
            }

            $http({
                method: 'POST',
                url: url,
                cache: false,
                withCredentials: true,
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                transformRequest: function (obj) {
                    //Deze transformatie is nodig icm Content-Type anders krijg je een 404 preflight error (http://stackoverflow.com/questions/24710503/how-do-i-post-urlencoded-form-data-with-http-in-angularjs)
                    var str = [];
                    for (var p in obj)
                        str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
                    return str.join("&");
                },
                data: data
                //data: { productId: $scope.product.Id, partnumberCode: $scope.partnumber.code, productType: $scope.product.ProductType, quantity: 1, dealerCode: (dealerCode != null ? dealerCode : null), globalCatalogue: $scope.product.IsGlobalCatalogue, GAclientId: $scope.GAclientId(), supplementaryItemPartnumberCode: $scope.supplementaryItemPartnumberCode },
            }).then(function (res) {
                angular.element('#ModalLocalStockFinder').modal('hide');
                if (res.data.result > 0) {

                    var cart = angular.element(document.getElementById('app-cart')).scope();
                    cart.getCartSummary();
                    //angular.element(document.getElementById('app-cart')).scope().$emit('getCartSummary');
                    //$rootScope.$broadcast('cartUpdated');

                    angular.element('#cartModal').modal('show');

                    AnalyticsBuilder.create(window.inTestMode ? { debug: true } : {}).addProduct({
                        'id': $scope.partnumber.code,
                        'name': $scope.product.Name,
                        'quantity': 1
                    }).asAddToCart({
                        'id': $scope.partnumber.code,
                        'name': $scope.product.Name,
                        'quantity': 1
                    }).send({
                        label: dealerCode != null && dealerCode.length > 0 ? 'Pick it up here' : 'Add to cart'
                    });
                } else {
                    angular.element('#cartModalError').modal('show');
                    //if ($scope.GiftcardRecipientEmail != undefined) {
                    //    $scope.errorGiftcard = res.data.exceptionmessage;
                    //}
                    $scope.addCartItemError = res.data.exceptionmessage;
                }
            });
        });
    }

    $scope.changeColorDropdown = function (cloudinaryImageToPartnumbers) {
        if (cloudinaryImageToPartnumbers.Color != null && cloudinaryImageToPartnumbers.Color.length > 0) {
            //image related to partnumber
            $scope.color = cloudinaryImageToPartnumbers.Color;
            $scope.selectColor2(cloudinaryImageToPartnumbers);

            setTimeout(function () {
                angular.element('#colorSelect .selectpicker').selectpicker('refresh');
            });
        } else {
            //image NOT related to partnumber
            if ($scope.colors.length > 1) {
                //nodig indien een foto is aangeklikt die niet gerelateerd is aan een kleur.
                $scope.color = '';
            }
            $scope.activeImageMain = cloudinaryImageToPartnumbers.CloudinaryImage.ImageUrlMain;
            $scope.activeImageLarge = cloudinaryImageToPartnumbers.CloudinaryImage.ImageUrlLarge;
            $scope.activeImageSmall = cloudinaryImageToPartnumbers.CloudinaryImage.ImageUrlSmall;
            $scope.activeImageThumb = cloudinaryImageToPartnumbers.CloudinaryImage.ImageUrlThumb;
            $scope.activeImageZoom = cloudinaryImageToPartnumbers.CloudinaryImage.ImageUrlZoom;
            $scope.activeImageIndex = $scope.product.CloudinaryImagesToPartnumbers.indexOf(cloudinaryImageToPartnumbers);
            $scope.selectColor2(cloudinaryImageToPartnumbers);
        }
    };

    $scope.changeZoomedImageModal = function (cloudinaryImageToPartnumbers) {
        $scope.activeImageZoom = cloudinaryImageToPartnumbers.CloudinaryImage.ImageUrlMegaZoom;
    };


    $scope.compare = function (e) {
        var data = {
            globalcatalogue: $scope.product.IsGlobalCatalogue == true ? "True" : "False",
            id: $scope.product.Id,
            image: $scope.product.Image,
            name: $scope.product.Name
        };

        window.compareStore.add(data);
    }

    $scope.sendStockAlert = function () {
        $scope.errorStockAlert = '';
        if ($scope.formStockAlert.$valid) {
            cartService.MasterDomain().then(function () {
                var url = cartService._masterDomain + '/' + $window.culture + '/shop/stockalert' + ($window.store != undefined && $window.store.length > 0 ? '?store=' + $window.store : '');
                $http({
                    method: 'POST',
                    url: url,
                    cache: false,
                    withCredentials: true,
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                    transformRequest: function (obj) {
                        //Deze transformatie is nodig icm Content-Type anders krijg je een 404 preflight error (http://stackoverflow.com/questions/24710503/how-do-i-post-urlencoded-form-data-with-http-in-angularjs)
                        var str = [];
                        for (var p in obj)
                            str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
                        return str.join("&");
                    },
                    data: { partnumberCode: $scope.partnumber.code, email: $scope.notificationEmail, zipcode: $scope.notificationZipcode },
                }).then(function (res) {
                    if (res.data == "True") {
                        angular.element('#stockAlertModal').modal('hide');
                    } else {
                        $scope.errorStockAlert = res.data;
                    }
                });
            });
        } else {
            if ($scope.formStockAlert.$error.required != undefined && $scope.formStockAlert.$error.required.length > 0) {
                $scope.errorStockAlert += lblMakeSureAllRequiredFieldsAreEntered;
            }
            if ($scope.formStockAlert.$error.email != undefined && $scope.formStockAlert.$error.email.length > 0) {
                $scope.errorStockAlert += lblWrongEmailHasBeenEntered;
            }
        }
    }

    $scope.sendContactForm = function () {
        $scope.errorContact = '';
        if ($scope.formContact.$valid) {
            var url = '/' + $window.culture + '/contact/sendjson';
            $http({
                method: 'POST',
                url: url,
                cache: false,
                withCredentials: true,
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                transformRequest: function (obj) {
                    //Deze transformatie is nodig icm Content-Type anders krijg je een 404 preflight error (http://stackoverflow.com/questions/24710503/how-do-i-post-urlencoded-form-data-with-http-in-angularjs)
                    var str = [];
                    for (var p in obj)
                        str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
                    return str.join("&");
                },
                data: { Name: $scope.contactName, email: $scope.contactEmail, question: $scope.contactQuestion, ProductId: $scope.contactProductId, ProductType: $scope.contactProductType, isGlobalCatalogue: $scope.contactIsGlobalCatalogue },
            }).then(function (res) {
                if (res.data == "True") {
                    angular.element('#contactModal').modal('hide');
                } else {
                    $scope.errorContact = res.data;
                }
            });
        } else {
            if ($scope.formContact.$error.required != undefined && $scope.formContact.$error.required.length > 0) {
                $scope.errorContact += lblMakeSureAllRequiredFieldsAreEntered;
            }
            if ($scope.formContact.$error.email != undefined && $scope.formContact.$error.email.length > 0) {
                $scope.errorContact += lblWrongEmailHasBeenEntered;
            }
        }
    }

    $scope.IsMobile = function () {
        return helpers.isMobile();
    }

    $scope.isIOS = function () {
        if (window.ApplePaySession) {
            //alert("canMakePaymentsWithActiveCard");
            var merchantIdentifier = 'merchant.giant-bicycles.com';
            var promise = ApplePaySession.canMakePaymentsWithActiveCard(merchantIdentifier);
            //alert(promise);
            promise.then(function (canMakePayments) {
                //alert(canMakePayments);
                if (canMakePayments) {
                    $scope.IOS = true;
                    //HTMLCollection.prototype[Symbol.iterator] = Array.prototype[Symbol.iterator];
                    //var buttons = document.getElementsByClassName("apple-pay-button");
                    //for (let button of buttons) {
                    //    button.className += " visible";
                    //}
                }
            });
        } else {
            //alert('NO');
            //return false;
        }
    }

    $scope.getPaymentOption = function (code) {
        if ($scope.Cart.PaymentOptions != null) {
            for (var i = 0; i < $scope.Cart.PaymentOptions.length; i++) {
                if ($scope.Cart.PaymentOptions[i].code == code && $scope.Cart.PaymentOptions[i].show == true) {
                    return $scope.Cart.PaymentOptions[i];
                }
            }
        }
    }

    $scope.resetContactInfo = function () {
        cartService.MasterDomain().then(function () {
            var url = cartService._masterDomain + '/' + $window.culture + '/shop/resetcontactinfo';
            $http({
                method: 'POST',
                url: url,
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                withCredentials: true
            }).then(function (res) {
                location.reload();
            });
        });
    }

    $scope.selectPartnumberByBarcode = function (barcode) {
        for (i = 0; i < $scope.partnumbers.length; i++) {
            if ($scope.partnumbers[i].barcode == barcode) {
                $scope.partnumberCode = $scope.partnumbers[i].code
                $scope.partnumber = $scope.partnumbers[i];
                $scope.selectPartnumber();
                setTimeout(function () {
                    angular.element('#sizes.selectpicker').selectpicker('refresh');
                });
                break;
            }
        }

    }

    $scope.validateAddress = function () {
        if (window.inTestMode == undefined && validateAddressHousenumber && $scope.Cart.Order != null && $scope.Cart.Order.Street != null && $scope.Cart.Order.Street.length > 0) {
            $scope.containsValidAddress = /\d/.test($scope.Cart.Order.Street);
        }
    }

    $scope.runAwardClick = function (awardUrl, openInNewWindow) {

        console.log(openInNewWindow);

        if (awardUrl != undefined && awardUrl.length > 0) {
            // track click
            trackEventGlobalAndLocal('Award', 'Click', awardUrl);
            // go to url
            if (openInNewWindow) {
                $window.open(awardUrl, '_blank');
            } else {
                $window.open(awardUrl, '_self');
            }
        }
    }

    $scope.getBrowserlocation = function () {
        helpers.getBrowserLocation(function (lat, lng, dealercity) {
            $scope.latlng = lat + ',' + lng;
            $scope.dealercity = dealercity;
            $scope.$apply();
            $('#latlng').val($scope.latlng);
            $('#keyword').val($scope.dealercity);
            $('form#Geocoder').submit();
        });
    }

    $scope.getGeolocationStoreMinimal = function () {
        helpers.getGeolocation($scope.dealercity, function (lat, lng) {
            $scope.latlng = lat + ',' + lng;
            $scope.$apply();
            $('#latlng').val($scope.latlng);
            console.log('Search: ' + $scope.dealercity + ' ' + $scope.country + ', Result: ' + $scope.latlng);
            $('form#Geocoder').submit();
        });
    };

    $scope.changeTaxDocument = function () {
        if ($scope.Cart.Order.TaxDocument == false) {
            $scope.Cart.Order.ClientType = '';
            $scope.Cart.Order.VATNum = '';
            $scope.Cart.Order.VATName = '';
        } else {
            $scope.Cart.Order.ClientType = 'individual';
        }
    }

    $scope.otherAmountClick = function () {
        $scope.otherAmountClicked = true;
        $scope.GiftcardPrice = '';
        setTimeout(function () {
            $('#otheramount').focus();
        });
    }

    $scope.amountClick = function (amount) {
        $scope.GiftcardPrice = amount;
        $scope.otherAmountClicked = false;
    }

    $scope.getGiftcardBalance = function () {
        if ($scope.GiftcardNumber.length > 0) {
            $scope.GiftcardValue = '';
            $scope.errorGiftcardBalance = '';
            $scope.GiftcardExpirationDate = '';

            grecaptcha.ready(function () {
                grecaptcha.execute(window.GoogleRecaptchaSiteKey, { action: 'social' })
                    .then(function (token) {
                        var url = '/' + $window.culture + '/giftcard/balance';
                        $http({
                            method: 'POST',
                            url: url,
                            cache: false,
                            withCredentials: true,
                            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                            transformRequest: function (obj) {
                                //Deze transformatie is nodig icm Content-Type anders krijg je een 404 preflight error (http://stackoverflow.com/questions/24710503/how-do-i-post-urlencoded-form-data-with-http-in-angularjs)
                                var str = [];
                                for (var p in obj)
                                    str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
                                return str.join("&");
                            },
                            data: { GiftcardNumber: $scope.GiftcardNumber, Token: token }
                        }).then(function (res) {
                            $scope.GiftcardValue = res.data.result;
                            $scope.errorGiftcardBalance = res.data.exception;
                            $scope.GiftcardExpirationDate = res.data.expirationdate;
                            $scope.GiftcardNumber = '';
                        });
                    });
            });
        }
    }
}]);

angular.element(document).ready(function () {
    try {
        var appID = document.getElementById('app-shop');
        angular.bootstrap(appID, ['app-shop']);
    } catch (e) {
        //do nothing
    }
});